<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header d-flex">
      <bread-crumb></bread-crumb>
      <b-alert
        v-model="showAlertTop"
        variant="danger"
        class="ml-5 transaction-alert"
        dismissible
      >
        <h4 class="alert-heading">Error!</h4>
        <p class="mb-0">
          Whenever you need to, be sure to use margin utilities to keep things
          nice and tidy.
        </p>
      </b-alert>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>{{ teamViewTitle }}</h2>
          </div>
          <!-- Transaction Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-lg-0 py-3"
            >
              <!-- <div class="p-2 mr-auto">
                                <VMdDateRangePicker class="pull-right" opens='left' v-model="dateRange" @change="getSelectedDateRange($event)" :presets="presets" :autoApply="false"></VMdDateRangePicker>
                            </div> -->
              <!-- SearchBox Filters -->
              <!-- <div class="d-flex align-items-center flex-column flex-md-row-reverse justify-content-center justify-content-md-start mb-3 payment-dropdown"> -->
              <!-- <b-dropdown v-if="false" class="mr-0 mw-" id="download" text="Download" size="lg" variant="outline-primary btn-mw">
                                    <template #button-content>
                                        Download <i class="fa fa-download"></i>
                                    </template>
                                    <b-dropdown-item href="">Export as PDF</b-dropdown-item>
                                    <b-dropdown-item href="">Export as Excel</b-dropdown-item>
                                    <b-dropdown-item href="">Export as CSV</b-dropdown-item>
                                </b-dropdown> -->
              <div class="mr-0 mr-lg-3 action-top-search py-lg-3 py-0">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchText"
                    placeholder="Enter Keywords"
                    aria-label="Enter Keywords"
                    aria-describedby="search-transactions"
                    v-on:keyup.enter="getTransactionList"
                  />
                  <div
                    class="input-group-append"
                    @click="searchText ? getTransactionList() : '-'"
                  >
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <!-- <div class="fliter-main mr-auto mt-3 mt-lg-0">
                                    <b-button class="fliter-btn btn-lg btn-mw"
                                        :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                                        @click="isVisibleFilter = !isVisibleFilter">Filter <i class="fa fa-filter"
                                            aria-hidden="true"></i></b-button>
                                </div> -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0 py-lg-3 py-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- </div> -->
              <div
                class="filter-select d-flex flex-md-row flex-column mt-3 mt-lg-0 py-lg-3 py-0"
              >
                <div
                  class="d-flex flex-sm-row flex-column"
                  v-if="
                    this.transactions.filter((data) => data.selected === true)
                      .length > 0
                  "
                >
                  <div class="country-dropdown curancy-dropdown mb-0">
                    <div
                      class="form-group form-select single-multiselect mb-0 mr-sm-2"
                    >
                      <span class="float-label">
                        <label for="bulkcapture">Bulk Payout</label>
                        <multiselect
                          placeholder="Select option"
                          v-model="bulkCapturestatus"
                          :show-labels="false"
                          :options="bulkCaptureOption"
                          :searchable="false"
                          @input="showalertForbulkcapture"
                        ></multiselect>
                      </span>
                    </div>
                  </div>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.bulk'])">
                    <b-button
                      class="fliter-btn btn-lg btn-mw mr-2 mt-1 mt-sm-0"
                      variant="primary"
                    >
                      Bulk Capture
                    </b-button>
                  </template>
                </div>
                <!-- <div class="country-dropdown curancy-dropdown mb-0 mt-md-0 mt-3">
                                    <div class="form-group form-select single-multiselect mb-0">
                                        <span class="float-label">
                                        <label for="roles">Select Tradename</label>
                                        <multiselect
                                            placeholder="Select Tradename"
                                            v-model="tradename" 
                                            :show-labels="false" 
                                            :options="tradename_options" 
                                            :searchable="false"
                                            label="name"
                                            @select="setprovider">
                                        </multiselect>  
                                        </span>
                                    </div>
                                </div> -->
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'firstname' ||
                          item.field.id == 'lastname' ||
                          item.field.id == 'receiverfirstname' ||
                          item.field.id == 'receiverlastname' ||
                          item.field.id == 'receivermiddlename' ||
                          item.field.id == 'senderemail' ||
                          item.field.id == 'receiveremail' ||
                          item.field.id == 'senderphone' ||
                          item.field.id == 'receiverphone' ||
                          item.field.id == 'middlename' ||
                          item.field.id == 'payment_res_id' ||
                          item.field.id == 'payout_res_id' ||
                          item.field.id == 'transaction_ref' ||
                          item.field.id == 'ip_address' ||
                          item.field.id == 'bank_name')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'mobile_network'"
                    >
                      <span class="float-label w-100">
                        <label>Select Mobile Money Network</label>
                        <v-select
                          v-model="item.mobile_network"
                          :options="momoProviderList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'remitterstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select Remiter Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="remiterOption"
                          label="name"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>

                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'payout_source'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout type</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.type"
                            :show-labels="false"
                            :options="filterpayouttype"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @select="selectPayout"
                          ></multiselect>
                        </span>
                      </div>
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                        v-if="item.payout.type"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout Source</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.source"
                            :show-labels="false"
                            :options="payoutSourceOption"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @search-change="searchPayoutSource"
                          ></multiselect>
                        </span>
                      </div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Dest. Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                          @input="getCountryWiseMomoProvider(item.country)"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'sourcecountry'"
                    >
                      <span class="float-label w-100">
                        <label>Select Source Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transaction_status'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">
                          Select Transaction Status
                        </label>
                        <multiselect
                          placeholder=""
                          v-model="item.transactionStatus"
                          :show-labels="false"
                          :options="transactionStatus"
                          multiple
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transactiontype'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Transaction Type</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="transactionTypeFilterOptions"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'cko_capture'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">CKO Capture Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="[
                            { value: 'captured', name: 'Captured' },
                            { value: 'not_captured', name: 'To be Captured' },
                          ]"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'payment_id'"
                    >
                      <span class="float-label w-100">
                        <label>Select Payment Method</label>
                        <multiselect
                          v-model="item.search"
                          :options="paymentMethodOptions"
                          :searchable="true"
                          placeholder="Select Payment Method"
                          label="name"
                          track-by="value"
                          :show-labels="false"
                        >
                        </multiselect>
                      </span>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'amount'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label">
                          <label for="transaction">Select</label>
                          <multiselect
                            placeholder=""
                            v-model="item.amount.type"
                            :show-labels="false"
                            :options="amountOptions"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            @select="amountFieldUpdate"
                          ></multiselect>
                        </span>
                        <div class="line"></div>
                      </div>
                      <div class="form-group m-0 column-2-half">
                        <input
                          class="form-control"
                          type="text"
                          v-model="item.amount.value"
                          :placeholder="'Enter ' + item.field.name"
                          @keypress="onlyNumber($event)"
                        />
                        <div class="line"></div>
                      </div>
                    </div>
                    <div
                      class="column-2"
                      v-if="
                        item.field && item.field.id == 'transaction_history'
                      "
                    >
                      <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="sender"
                            v-model="item.history.sender"
                            placeholder="Enter sender PA ID"
                          />
                          <label for="sender" class="control-label">
                            Enter sender PA ID
                          </label>
                          <div class="line"></div>
                        </span>
                      </div>
                      <!-- <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="receiver"
                            v-model="item.history.receiver"
                            placeholder="Enter receiver PA ref"
                          />
                          <label for="receiver" class="control-label"
                            >Enter receiver PA ref</label
                          >
                          <div class="line"></div>
                        </span>
                      </div> -->
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel & Close
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template
                  v-if="
                    item.filter_field == 'country' ||
                    item.filter_field == 'sourcecountry'
                  "
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter(
                        (data) => data.countryid === country,
                      )[0]?.countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for transaction status filter-->
                <template v-if="item.filter_field == 'transaction_status'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="status in item.filter_value"
                    :key="status"
                  >
                    {{ transactionStatus.filter((data) => data === status)[0] }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeStatus(status, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for Date -->
                <template v-else-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for Date -->
                <!--<template v-else-if="item.filter_field == 'payout_source'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date"
                      >{{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removePayoutSource(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>-->
                <!-- Only for transaction_history -->
                <template
                  v-else-if="item.filter_field == 'transaction_history'"
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(item, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="item">
                      {{ indexValue + ": " + item }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removetransaction_history(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for mobile_network filter-->
                <template v-if="item.filter_field == 'mobile_network'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="networkId in item.filter_value"
                    :key="networkId"
                  >
                    {{
                      (item._mobile_network_objs
                        ? item._mobile_network_objs.find(
                            (opt) => (opt.id || opt.value || opt) === networkId,
                          )?.name
                        : networkId) || networkId
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="
                        removeNetwork(networkId, item.filter_field, index)
                      "
                    ></i>
                  </span>
                </template>
                <!-- Only for payment method filter -->
                <template v-else-if="item.filter_field == 'payment_id'">
                  <span class="badge badge-warning-solid mr-1">
                    {{ item.filter_label || item.filter_value }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeFilter(index)"
                    ></i>
                  </span>
                </template>
                <!-- Other filter -->
                <span
                  class="badge badge-warning-solid"
                  v-else-if="
                    typeof item.filter_value === 'string' ||
                    typeof item.filter_value === 'number'
                  "
                >
                  {{ item.filter_value }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Transaction List -->
            <b-table
              responsive
              ref="transactionTable"
              table-class="mb-0 table-custom border transaction-list-table"
              head-variant="light"
              :items="
                typeof transactions === 'array' ||
                typeof transactions === 'object'
                  ? transactions
                  : []
              "
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              :emptyText="'No data found.'"
              show-empty
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #head(selected)>
                <div class="fancy-checkbox mr-0">
                  <label class="mb-0">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @click="bulkSelectall"
                    />
                    <span></span>
                  </label>
                </div>
              </template>
              <template #cell(selected)="data">
                <div class="fancy-checkbox mr-0 mt-2">
                  <label>
                    <input type="checkbox" v-model="data.item.selected" />
                    <span></span>
                  </label>
                </div>
              </template>
              <template #cell(srccountry)="data">
                <div class="d-flex align-items-center">
                  <span :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country?.countryname"
                  >
                    {{ data.item.country?.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(sender)="data">
                <div>
                  <img
                    v-if="data.item.customerGroup == 'Basic'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-basic.svg`)"
                  />
                  <img
                    v-else-if="
                      data.item.customerGroup == 'GREY - Unvalidated Profiles'
                    "
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-grey.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Silver'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-silver.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Silver+'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="
                      require(`@/assets/account-type-svg/plan-silver-plus.svg`)
                    "
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Bronze'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-bronze.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Red'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-red.svg`)"
                  />
                  <a
                    class="font-color font-weight-bold"
                    href="javascript:void(0);"
                    @click="customerDetailModel(data.item.customer_id)"
                    :id="`tooltip${data.index}`"
                  >
                    <!-- :class="{'text-warning': (data.index == 1)}" -->
                    {{ data.value.name.substring(0, 19) }}
                    <span v-if="data.value.name.length > 19">...</span>
                  </a>
                  <span
                    v-if="senderRiskFor(data.item.customer_id)"
                    class="badge risk-pill d-block mt-1"
                    :class="'risk-' + senderRiskFor(data.item.customer_id).toLowerCase()"
                    v-b-tooltip.hover
                    title="Remitter linked risk"
                  >
                    {{ senderRiskFor(data.item.customer_id) }} risk
                  </span>
                  <span
                    v-else-if="riskLoading && data.item.customer_id"
                    class="risk-skeleton d-block mt-1"
                    title="Assessing risk…"
                  ></span>
                  <span
                    v-else-if="data.item.customer_id"
                    class="risk-na d-block mt-1"
                    v-b-tooltip.hover
                    title="No linked-risk data for this remitter"
                    >N/A</span
                  >
                  <b-tooltip
                    :target="`tooltip${data.index}`"
                    placement="right"
                    custom-class="customer-tooltip"
                  >
                    <h6 class="p-2 border-bottom text-left">
                      Customer Details
                    </h6>
                    <div class="tooltip-body p-2 text-left">
                      <div class="d-flex">
                        <div class="pb-2 label">Country:</div>
                        <div class="pb-2 value">
                          {{
                            data.item.country?.countryname
                              ? data.item.country.countryname
                              : "-"
                          }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">No of Cards:</div>
                        <div class="pb-2 value">{{ data.item.senderCard }}</div>
                      </div>
                      <template v-if="data.item.senderActiveCards != null">
                        <div class="d-flex card-state">
                          <div class="pb-2 label">Active:</div>
                          <div class="pb-2 value card-state-active">
                            {{ data.item.senderActiveCards }}
                          </div>
                        </div>
                        <div class="d-flex card-state">
                          <div class="pb-2 label">Deleted:</div>
                          <div class="pb-2 value">
                            {{ data.item.senderDeletedCards }}
                          </div>
                        </div>
                        <div class="d-flex card-state">
                          <div class="pb-2 label">Blocked:</div>
                          <div class="pb-2 value">
                            {{ data.item.senderBlockedCards }}
                          </div>
                        </div>
                        <div class="pb-2 card-state-note">
                          A card can be both deleted and blocked, so these may
                          add up to more than the total.
                        </div>
                      </template>
                      <div class="d-flex">
                        <div class="pb-2 label">DTV:</div>
                        <!-- <div class="pb-2 value font-weight-bold text-warning" v-if="data.index == 1"> 3750</div> -->
                        <div class="pb-2 value">{{ data.item.senderDTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">MTV:</div>
                        <div class="pb-2 value">{{ data.item.senderMTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">LTV:</div>
                        <div class="pb-2 value">{{ data.item.senderLTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">No of Receivers:</div>
                        <div class="pb-2 value">
                          {{ data.item.noOfReceiver }}
                        </div>
                      </div>
                    </div>
                  </b-tooltip>
                </div>
              </template>
              <template #cell(benificiary)="data">
                <a
                  class="font-color font-weight-bold"
                  href="javascript:void(0);"
                  @click="openReceiverDetails(data.item)"
                >
                  {{ data.value.name.substring(0, 19) }}
                  <span v-if="data.value.name.length > 19">...</span>
                </a>
                <span
                  v-if="receiverRiskFor(data.item.receiver_id)"
                  class="badge risk-pill d-block mt-1"
                  :class="'risk-' + receiverRiskFor(data.item.receiver_id).toLowerCase()"
                  v-b-tooltip.hover
                  title="Receiver linked risk"
                >
                  {{ receiverRiskFor(data.item.receiver_id) }} risk
                </span>
                <span
                  v-else-if="riskLoading && data.item.receiver_id"
                  class="risk-skeleton d-block mt-1"
                  title="Assessing risk…"
                ></span>
                <span
                  v-else-if="data.item.receiver_id"
                  class="risk-na d-block mt-1"
                  v-b-tooltip.hover
                  title="No receiver linked-risk (e.g. a self-transfer or no separate beneficiary record)"
                  >N/A</span
                >
              </template>
              <template #cell(custRefno)="data">
                <div>
                  <span class="mw-15 d-inline-block">
                    <i
                      :class="data.item.platform"
                      aria-hidden="true"
                      v-if="data.item.platform"
                    ></i>
                  </span>
                  <a
                    class="font-color"
                    href="javascript:void(0);"
                    @click="transactionDetails(data.item)"
                  >
                    {{ data.value }}
                  </a>
                  <i
                    class="fa fa-copy"
                    v-if="data.value != '-'"
                    @click="copyText(data.value, 'PA Ref')"
                  ></i>
                </div>
                <div class="d-block">
                  <span class="mw-15 d-inline-block">
                    <i
                      class="fa fa-times text-danger"
                      v-if="data.item.isCaptured == 0"
                    ></i>
                    <i class="fa fa-check text-success" v-else></i>
                  </span>
                  <span class="mw-15 d-inline-block">
                    <i
                      :class="data.item.platform"
                      aria-hidden="true"
                      v-if="data.item.platform"
                    ></i>
                  </span>
                  <span
                    :class="[
                      data.item.paymentProvider.class,
                      data.item.paymentMethodId ===
                      'fb491477-9b4a-410a-a008-a528ed1c0d27'
                        ? 'text-blue'
                        : data.item.paymentMethodId ===
                              'fb491477-9b4a-410a-a008-a528ed1c0d24' ||
                            data.item.paymentMethodId ===
                              'fb491477-9b4a-410a-a008-a528ed1c0d25'
                          ? 'text-warning'
                          : '',
                    ]"
                  >
                    {{ data.item.payment_res_id.substring(0, 12) }}
                    <span v-if="data.item.payment_res_id.length > 12">...</span>
                  </span>
                  
                  <i
                    class="fa fa-copy"
                    v-if="data.item.payment_res_id != '-'"
                    @click="copyText(data.item.payment_res_id, 'Payment Ref')"
                  ></i>
                </div>
                <!-- <div class="text-grey d-block">
                  <span class="mw-15 d-inline-block"></span
                  >{{ data.item.payout_res_id }}
                  <i
                    class="fa fa-copy"
                    v-if="data.item.payout_res_id != '-'"
                    @click="copyText(data.item.payout_res_id, 'Payout Ref')"
                  ></i>
                </div> -->
              </template>
              <template #cell(datetime)="data">
                <strong>{{ data.value | YYYYMMDD }}</strong>
                <small class="text-grey d-block">
                  {{ data.value | TIME }}
                </small>
              </template>
              <template #cell(accno)="data">
                <div class="align-items-center d-flex">
                  <span :id="`tooltip_accno${data.index}`">
                    <div>
                      <i
                        :class="`fa ${
                          data.value.type == 'bank'
                            ? 'fa-university'
                            : data.value.type == 'wallet'
                              ? 'fa-credit-card'
                              : 'fa-mobile'
                        } text-${
                          data.value.type == 'bank'
                            ? 'success'
                            : data.value.type == 'wallet'
                              ? 'success'
                              : 'info'
                        }`"
                        class="mr-1"
                      ></i>
                      <strong>
                        {{
                          data.value.type == "wallet"
                            ? data.value.acc
                            : data.value.acc | TRIMTEXT
                        }}
                      </strong>
                      <br />
                      <small
                        v-if="
                          data.value.type == 'wallet' &&
                          data.item.merchantReceiver
                        "
                        class="text-muted"
                      >
                        {{ data.item.merchantReceiver }}
                      </small>
                    </div>
                    <div class="d-block">
                       <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.edit'])">
                        <i
                          v-if="data.value.type == 'mobile' && data.item.transactionStatusId == 6"
                          class="mr-1 fa fa-edit text-info cursor-pointer"
                          @click="mobileNetworkEdit(data.item)"
                        ></i>
                        <!-- <i
                          v-if="data.value.type == 'bank'"
                          class="mr-1 fa fa-edit text-info cursor-pointer"
                          @click="bankAccountEdit(data.item)"
                        ></i> -->
                      </template> 
                      <span
                        class="cursor-pointer"
                        @click="viewAccounts(data.item)"
                      >
                        {{ data.value.no }}
                      </span>
                      <i
                        class="fa fa-copy"
                        v-if="data.value.no != '-'"
                        @click="copyText(data.value.no, 'Account Number')"
                      ></i>
                    </div>
                  </span>
                </div>
                <b-tooltip
                  :target="`tooltip_accno${data.index}`"
                  placement="right"
                  custom-class="customer-tooltip"
                >
                  <div class="tooltip-body p-2 text-left">
                    <h6 class="p-2 border-bottom text-left">
                      {{
                        data.value.type == "wallet"
                          ? "Wallet Details"
                          : "Account Details"
                      }}
                    </h6>
                    <div v-if="data.value.type == 'wallet'">
                      <div class="d-flex">
                        <div class="pb-2 label">Wallet Name:</div>
                        <div class="pb-2 value ml-1">{{ data.value.acc }}</div>
                      </div>
                      <div class="d-flex" v-if="data.item.merchantReceiver">
                        <div class="pb-2 label">Business ID:</div>
                        <div class="pb-2 value ml-1">
                          {{ data.item.merchantReceiver }}
                        </div>
                      </div>
                      <div
                        class="d-flex"
                        v-if="data.item.businessWalletTransactionId"
                      >
                        <div class="pb-2 label">Transaction ID:</div>
                        <div class="pb-2 value ml-1">
                          {{ data.item.businessWalletTransactionId }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-flex">
                        <div class="pb-2 label">Linked Accounts:</div>
                        <div class="pb-2 value ml-1">0</div>
                      </div>
                    </div>
                  </div>
                </b-tooltip>
              </template>

              <template #cell(sourceamount)="data">
                <span
                  class="d-block"
                  v-if="data.value != 'N/A'"
                  v-b-tooltip.hover
                  :title="data.item.country?.countryname"
                >
                  {{ data.value | amountFormat(data.item.sourceCurrencyCode) }}
                </span>
                <span v-else>{{ data.value }}</span>
              </template>
              <template #cell(destamount)="data">
                <span
                  class="d-block"
                  v-if="data.value != 'N/A'"
                  v-b-tooltip.hover
                  :title="data.item.destcountry?.countryname"
                >
                  {{ data.value | amountFormat(data.item.destCurrencyCode) }}
                </span>
                <span v-else>{{ data.value }}</span>
              </template>
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <select
                    class="btn btn-filter badge w-100"
                    :class="data.value.class"
                    v-if="data.value.name == 'Failed' && !hasPendingReroute(data.item)"
                    v-model="data.value.name"
                    @change="transactionProcessPayout(data.item)"
                  >
                    <option selected disabled>{{ data.value.name }}</option>
                    <option value="Retry">Retry</option>
                  </select>
                  <select
                    class="btn btn-filter badge w-100"
                    :class="data.value.class"
                    v-else-if="
                      data.value.name == 'Sent for Payment' ||
                      data.value.name == 'Awaiting Callback'
                    "
                    v-model="data.value.name"
                    @change="statusCheck(data.item)"
                  >
                    <option selected disabled>{{ data.value.name }}</option>
                    <option value="Check status">
                      Check Transaction Status
                    </option>
                  </select>
                  <span v-else class="badge w-100" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                  <!-- <i v-if="data.value.name == 'Failed'" class="fa fa-repeat text-danger"  v-b-tooltip.hover title="Retry"></i> -->
                </div>
              </template>
              <template #cell(payout)="data" v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.process'])">
                <span
                  v-if="blockedEntities.includes(data.item.accno.no)"
                  class="badge badge-danger"
                  style="font-size: 0.85em; padding: 0.4em 0.6em;"
                >
                  Suspicious Phone Number
                </span>
                <div v-else-if="hasPendingReroute(data.item)">
                  <span
                    :id="`reroute-pill-${data.index}`"
                    class="reroute-pill"
                    tabindex="0"
                  >
                    ({{ data.item.pendingReroutes.length }}) pending
                    {{ data.item.pendingReroutes.length === 1 ? 'request' : 'requests' }}
                    <i class="fa fa-info-circle ml-1"></i>
                  </span>
                  <b-popover
                    :target="`reroute-pill-${data.index}`"
                    triggers="click blur"
                    placement="bottom"
                    boundary="window"
                    custom-class="reroute-popover"
                  >
                    <template #title>
                      {{ data.item.pendingReroutes.length }} pending reroute
                      {{ data.item.pendingReroutes.length === 1 ? 'request' : 'requests' }}
                    </template>
                    <div
                      v-for="(pr, prIndex) in data.item.pendingReroutes"
                      :key="prIndex"
                      class="reroute-popover-item"
                    >
                      <div class="reroute-popover-label">
                        <span class="reroute-popover-dot">&bull;</span>
                        <strong>{{ rerouteFieldsLabel(pr.correctionFields) }}</strong>
                      </div>
                      <div class="reroute-popover-meta">
                        by {{ pr.makerName }} on {{ formatRerouteTime(pr.submittedAt) }}
                      </div>
                    </div>
                  </b-popover>
                </div>
                <select
                  v-else
                  class="btn btn-filter badge badge-info"
                  v-model="data.item.payoutProvider"
                  @change="transactionProcessPayout(data.item)"
                  :disabled="
                    data.item.status.name === 'Recipient Paid' ||
                    data.item.status.name === 'In Review' ||
                    data.item.status.name === 'Awaiting Approval' ||
                    data.item.status.name === 'Refunded' ||
                    data.item.status.name === 'Ewallet Refunded'
                  "
                >
                  <option value=" " disabled>Select Option</option>
                  <option
                    v-for="(option, index) in getFilteredPayoutOptions(data.item)"
                    :key="index"
                    :value="option"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </template>
              <template #cell(action)="data">
                <!-- Suspicious mobile number - block all actions -->
                <template v-if="blockedEntities.includes(data.item.accno.no)">
                  <span class="badge badge-danger" style="font-size: 0.85em; padding: 0.4em 0.6em;">
                    <i class="fa fa-exclamation-triangle mr-1"></i>Needs Review
                  </span>
                </template>
                <!-- Awaiting Approval - No payout actions allowed -->
                <template
                  v-else-if="
                    data.item.status?.name === 'Awaiting Approval'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- Recipient Paid - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'recipient paid'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.notification'])">
                      <b-dropdown-item @click="sendNotification(data.item)">
                        Send Notification
                      </b-dropdown-item>
                    </template>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                    <b-dropdown-item @click="trans_status_update(data.item)">
                      Transaction Status Update
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- In Review - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'in review'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Processing',
                        )
                      "
                    >
                      Un Hold
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- Awaiting Callback - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'awaiting callback'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'In Review',
                        )
                      "
                    >
                      Hold
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="trans_payout_status_update(data.item)"
                    >
                      Payout Status Update
                    </b-dropdown-item>
                    <b-dropdown-item @click="trans_status_update(data.item)">
                      Transaction Status Update
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.transactionStatusId === 11 && data.item.latestPayoutProviderId !== null && data.item.latestPayoutProviderId !== 'fca8b4a7-b96e-4e54-98e1-2fa7a5019bbe'"
                      @click="manualConfirmSuccess(data.item)"
                    >
                      Transaction Success (Manual Confirm)
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.transactionStatusId === 11 && data.item.latestPayoutProviderId !== null && data.item.latestPayoutProviderId !== 'fca8b4a7-b96e-4e54-98e1-2fa7a5019bbe'"
                      @click="manualConfirmFailed(data.item)"
                    >
                      Transaction Failed (Manual Confirm)
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- Refunded / Ewallet Refunded - No actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'refunded' ||
                    data.item.status?.name?.toLowerCase() === 'ewallet refunded'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- Awaiting Funds - No actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'awaiting funds'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- All other statuses - Full actions -->
                <template v-else>
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.process'])">
                      <b-dropdown-item
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'Cancelled',
                          )
                        "
                      >
                        Cancel
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="data.item.status.name != 'In Review'"
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'In Review',
                          )
                        "
                      >
                        Hold
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="data.item.status.name == 'In Review'"
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'Processing',
                          )
                        "
                      >
                        Un Hold
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.autocapture'])">
                      <b-dropdown-item
                        v-if="data.item.isCaptured == 0"
                        @click="paymentCapture(data.item)"
                      >
                        Payment Capture
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.payoutstatus'])">
                      <b-dropdown-item
                        @click="trans_payout_status_update(data.item)"
                      >
                        Payout Status Update
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.notification'])">
                      <b-dropdown-item @click="sendNotification(data.item)">
                        Send Notification
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['reroute.maker']) && data.item.status.name === 'Failed' && isReroutableReference(data.item)">
                      <b-dropdown-item @click="rerouteAction(data.item, data.index)">
                        Send Reroute Request
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.status']) && !hasPendingReroute(data.item)">
                      <b-dropdown-item @click="trans_status_update(data.item)">
                        Transaction Status Update
                      </b-dropdown-item>
                    </template>
                    <template
                      v-if="
                        $store.getters['authpermission/hasAnyPermission']([
                          'transaction.status',
                        ]) && isPaymentVerifiable(data.item)
                      "
                    >
                      <b-dropdown-item @click="verifyPaymentAndUpdateStatus(data.item)">
                        Verify Payment &amp; Update Status
                      </b-dropdown-item>
                    </template>
                    <b-dropdown-item v-if="getSyncActionLabel(data.item)" @click="syncAction(data.item)">
                      {{ getSyncActionLabel(data.item) }}
                    </b-dropdown-item>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.downloadReceipt'])">
                      <!--
                        Shown only when a receipt file actually exists. pdfLink
                        is the stored filename reported by the list API; without
                        it the endpoint has nothing to return and 404s.
                      -->
                      <b-dropdown-item
                        v-if="hasReceipt(data.item)"
                        @click="viewTransactionPDF(data.item)"
                      >
                        Download Receipt
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="hasReceipt(data.item)"
                        @click="viewReceiptInTab(data.item)"
                      >
                        View Receipt
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
              </template>
            </b-table>
            <b-modal
              id="transactionProcess"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Transaction Process
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(transactionProcessSubmit)">
                    <ValidationProvider
                      name="reason"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            transactionProcess.reason &&
                            transactionProcess.reason.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="reason">Select Reason*</label>
                          <multiselect
                            placeholder=""
                            v-model="transactionProcess.reason"
                            :show-labels="false"
                            :options="transactionReasons"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              transactionProcess.reason &&
                              transactionProcess.reason.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="refund_method"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="transactionProcess.status == 'Cancelled'"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              transactionProcess.refundmethod &&
                              transactionProcess.refundmethod.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="refund_method">
                              Select Refund Method*
                            </label>
                            <multiselect
                              placeholder=""
                              v-model="transactionProcess.refundmethod"
                              :show-labels="false"
                              :options="refund_method_Options"
                              :searchable="false"
                            ></multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                transactionProcess.refundmethod &&
                                transactionProcess.refundmethod.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !transactionProcess.comment,
                          success: transactionProcess.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="transactionProcess.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !transactionProcess.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="transactionProcess.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="transactionProcessClearData()"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transactionNotification"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Send Notification
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(transactionNotificationSubmit)">
                    <ValidationProvider
                      name="notification_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.type &&
                            notification.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_type">
                            Notification Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.type"
                            :show-labels="false"
                            :options="notificationTypeOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.type &&
                              notification.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_action"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.action &&
                            notification.action.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_action">
                            Notification Action*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.action"
                            :show-labels="false"
                            :options="notificationActionOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.action &&
                              notification.action.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_custom"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="notification.action == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !notification.custom) ||
                            errors[0],
                          success: notification.custom && !errors[0],
                        }"
                      >
                        <span class="float-label mb-1">
                          <textarea
                            class="form-control"
                            id="notification_custom"
                            v-model="notification.custom"
                            placeholder=" "
                          ></textarea>
                          <label
                            for="notification_custom"
                            class="control-label"
                          >
                            Custom Notification Text*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !notification.custom) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="notification.custom && !errors[0]"
                          ></i>
                        </span>
                        <span class="text-danger">
                          <b>Note :-</b>
                          List of Placeholders: [trans_ref_#], [cust_name],
                          [trans_receiver]
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionNotification')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transactionStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Transaction Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="passes(statusUpdateSubmit('transaction'))"
                  >
                    <ValidationProvider
                      name="transaction_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            transactionStatusUpdate.status &&
                            transactionStatusUpdate.status.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transaction_status">
                            Transaction Status*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="transactionStatusUpdate.status"
                            :show-labels="false"
                            :options="UpdateStatusoption"
                            label="status"
                            track-by="status"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              transactionStatusUpdate.status &&
                              transactionStatusUpdate.status.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_cashflow"
                          v-model="transactionStatusUpdate.comment"
                          placeholder=" "
                        ></textarea>
                        <label for="transaction_cashflow" class="control-label">
                          Comment*
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="IBDStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  IBD Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(statusUpdateSubmit('IBD'))">
                    <ValidationProvider
                      name="IBD_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            IBDStatusUpdate &&
                            IBDStatusUpdate.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="IBD_status">IBD Status*</label>
                          <multiselect
                            placeholder=""
                            v-model="IBDStatusUpdate"
                            :show-labels="false"
                            :options="IBDStatusoption"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              IBDStatusUpdate &&
                              IBDStatusUpdate.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('IBDStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="payoutStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Payout Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="
                      passes(statusUpdateSubmit('payout_status'))
                    "
                  >
                    <ValidationProvider
                      name="transactionpayout_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: payoutStatusUpdate.provider && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transactionpayout_status">
                            Select Provider*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="payoutStatusUpdate.provider"
                            :show-labels="false"
                            :options="provideroption"
                            label="name"
                            track-by="providerid"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="payoutStatusUpdate.provider && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_comment"
                          v-model="payoutStatusUpdate.comment"
                          placeholder=" "
                        ></textarea>
                        <label for="transaction_comment" class="control-label">
                          Comment*
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('payoutStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transaction_comment"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">Comment</h5>
                <!-- {{comment_transaction.type}}  -->
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(commentSubmit())">
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !comment_transaction.comment,
                          success: comment_transaction.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="comment_transaction.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !comment_transaction.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="comment_transaction.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transaction_comment')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Manual Confirm Modal -->
            <b-modal
              id="manualConfirmModal"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  {{ manualConfirm.title }} — {{ manualConfirm.reference_number }}
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(manualConfirmSubmit)">
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !manualConfirm.comment,
                          success: manualConfirm.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            v-model="manualConfirm.comment"
                            class="form-control"
                            id="manual_confirm_comment"
                            placeholder=" "
                          ></textarea>
                          <label for="manual_confirm_comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i class="fa fa-times" v-if="errors.length && !manualConfirm.comment"></i>
                          <i class="fa fa-check" v-if="manualConfirm.comment"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="d-flex flex-column flex-md-row justify-content-center">
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('manualConfirmModal')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        :disabled="!manualConfirm.comment"
                      >
                        OK
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            
            <!-- AVS Warning Modal -->
            <b-modal
              id="avsWarningModal"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  AVS Check Warning
                </h5>
              </template>
              <div class="modal-area">
                <p class="mb-2">
                  The AVS check has not passed for this transaction.
                </p>
                <p class="mb-4 font-weight-bold">
                  Reason: {{ avsWarningReason }}
                </p>
                <p class="mb-4">
                  Do you want to proceed with the payout anyway?
                </p>
                <div class="d-flex flex-column flex-md-row justify-content-center">
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="cancelAvsOverride"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                    @click="confirmAvsOverride"
                  >
                    Yes, Proceed
                  </b-button>
                </div>
              </div>
            </b-modal>

            <!-- Edit Mobile Network -->
            <b-modal
              id="editMobileNetwork"
              size="md"
              title="Edit Number and Network"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Number and Network
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(updateMobileNetwork)">
                    <ValidationProvider
                      name="network"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: updateMobile.network && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="network">Select Network Name</label>
                          <multiselect
                            placeholder=""
                            v-model="updateMobile.network"
                            :show-labels="false"
                            :options="network_options"
                            label="name"
                            track-by="id"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateMobile.network && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <!-- <ValidationProvider
                      name="phoneNumber"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: mobileInputError == false,
                          success: updateMobile.phoneNumber && mobileInputError,
                        }"
                      >
                        <div class="float-label">
                          <label for="primary_number" class="control-label">
                            Mobile*
                          </label>
                          <vue-tel-input
                            v-model="updateMobile.phoneNumber"
                            v-bind="primaryMobileNumber"
                            @validate="mobileInputValidate"
                            ref="telInput"
                            @keydown.native="restrictSpecialCharacter($event)"
                            @paste.native="handlePhonePaste($event)"
                          >
                            <template v-slot:arrow-icon>
                              <span class="vti__dropdown-arrow">{{ "▼" }}</span>
                            </template>
                          </vue-tel-input>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              mobileInputError == false || isDisplayPhoneError
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="mobileInputError && updateMobile.phoneNumber"
                          ></i>
                        </div>
                        <span
                          class="text-danger error-msg"
                          v-if="errors && isDisplayPhoneError"
                        >
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider> -->
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !updateMobile.comment,
                          success: updateMobile.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="updateMobile.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateMobile.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateMobile.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="
                          $bvModal.hide('editMobileNetwork');
                          isDisplayPhoneError = false;
                        "
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Edit MOMO Details -->
            <b-modal
              id="editMomoDetails"
              size="md"
              title="Update MOMO Details"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Update MOMO Details
                </h5>
              </template>
              <div class="modal-area px-3 py-2">
              <p class="text-info" v-if="!editMomoDetailsModal.errorMessage">Please select the correct record to update the MOMO details.</p>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <h6 class="mb-1">Transaction Level</h6>
                    </div>
                    <!-- <span class="text-muted small">Click to select</span> -->
                  </div>
                  <div
                    class="border rounded px-3 py-3 mb-4"
                    :class="{
                      'border-primary bg-light': editMomoDetailsModal.selectedSection === 'transaction' || hoverSection === 'transaction',
                      'bg-white': editMomoDetailsModal.selectedSection !== 'transaction' && hoverSection !== 'transaction',
                    }"
                    @mouseover="hoverSection = editMomoDetailsModal.disableSubmit ? null : 'transaction'"
                    @mouseleave="hoverSection = null"
                    @click="selectMomoSection('transaction')"
                    :style="{ cursor: editMomoDetailsModal.disableSubmit ? 'default' : 'pointer' }"
                  >
                    <div class="d-flex justify-content-between mb-2">
                      <span class="font-weight-bold">MOMO Network</span>
                      <span>
                        {{
                          editMomoDetailsModal.transactiondata?.accno?.acc ||
                          'N/A'
                        }}
                      </span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span class="font-weight-bold">MOMO Number</span>
                      <span>
                        {{
                          editMomoDetailsModal.transactiondata?.accno?.no ||
                          'N/A'
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <h6 class="mb-1">Beneficiary Level</h6>
                    </div>
                    <!-- <span class="text-muted small">Click to select</span> -->
                  </div>
                  <div
                    class="border rounded px-3 py-3 mb-4"
                    :class="{
                      'border-primary bg-light': editMomoDetailsModal.selectedSection === 'beneficiary' || hoverSection === 'beneficiary',
                      'bg-white': editMomoDetailsModal.selectedSection !== 'beneficiary' && hoverSection !== 'beneficiary',
                    }"
                    @mouseover="hoverSection = editMomoDetailsModal.disableSubmit ? null : 'beneficiary'"
                    @mouseleave="hoverSection = null"
                    @click="selectMomoSection('beneficiary')"
                    :style="{ cursor: editMomoDetailsModal.disableSubmit ? 'default' : 'pointer' }"
                  >
                    <div v-if="editMomoDetailsModal.momodata.length === 0" class="text-muted">
                      No beneficiary MOMO record found.
                    </div>
                    <div v-else-if="editMomoDetailsModal.momodata.length === 1">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="font-weight-bold">MOMO Network</span>
                        <span>
                          {{
                            editMomoDetailsModal.momodata[0].mobileNetwork ||
                            'N/A'
                          }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">MOMO Number</span>
                        <span>
                          {{
                            editMomoDetailsModal.momodata[0].mobileNumber ||
                            'N/A'
                          }}
                        </span>
                      </div>
                    </div>
                    <div v-else class="beneficiary-scroll">
                      <div
                        v-for="(record, index) in editMomoDetailsModal.momodata"
                        :key="index"
                        class="border rounded mb-3 p-3"
                        :class="{
                          'bg-white': true,
                          'border-secondary': editMomoDetailsModal.momodata.length > 1,
                        }"
                      >
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <span class="font-weight-bold">Record {{ index + 1 }}</span>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                          <span class="font-weight-bold">MOMO Network</span>
                          <span>
                            {{
                              record.mobileNetwork ||
                              'N/A'
                            }}
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <span class="font-weight-bold">MOMO Number</span>
                          <span>
                            {{
                              record.mobileNumber ||
                              'N/A'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="editMomoDetailsModal.errorMessage" class="text-danger mb-3">
                  <h6>{{ editMomoDetailsModal.errorMessage }}</h6>
                </div>
                <div class="d-flex justify-content-end">
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$bvModal.hide('editMomoDetails')"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    v-if="!editMomoDetailsModal.disableSubmit"
                    variant="primary ml-2 btn-mw"
                    size="lg"
                    :disabled="!editMomoDetailsModal.selectedSection"
                    @click="submitEditMomoDetails"
                  >
                    Submit
                  </b-button>
                </div>
              </div>
            </b-modal>
            <!-- Edit Bank Account -->
            <b-modal
              id="editBankAccount"
              size="md"
              title="Edit Bank Account"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Bank Account
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(updateBankAccount)">
                    <ValidationProvider
                      name="bank"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: updateBank.bank && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="bank">Select Bank Name</label>
                          <multiselect
                            placeholder=""
                            v-model="updateBank.bank"
                            :show-labels="false"
                            :options="bank_options"
                            label="name"
                            track-by="name"
                          >
                          </multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.bank && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="account"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:  errors.length && !updateBank.account,
                          success: updateBank.account,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="updateBank.account"
                            class="form-control"
                            id="account"
                            placeholder="Account Number*"
                          />
                          <label for="account" class="control-label"
                            >Account Number*</label
                          >
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateBank.account"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.account"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !updateBank.comment,
                          success: updateBank.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="updateBank.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label"
                            >Comment*</label
                          >
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateBank.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="
                          $bvModal.hide('editBankAccount');
                        "
                        >Cancel</b-button
                      >
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        >Submit</b-button
                      >
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Edit Bank Details -->
            <b-modal
              id="editBankDetails"
              size="md"
              title="Update Bank Details"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Update Bank Details
                </h5>
              </template>
              <div class="modal-area px-3 py-2">
                <p class="text-info" v-if="!editBankDetailsModal.errorMessage">Please select the correct record to update the Bank details.</p>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <h6 class="mb-1">Transaction Level</h6>
                    </div>
                    <!-- <span class="text-muted small">Click to select</span> -->
                  </div>
                  <div
                    class="border rounded px-3 py-3 mb-4"
                    :class="{
                      'border-primary bg-light': editBankDetailsModal.selectedSection === 'transaction' || hoverSection === 'transaction',
                      'bg-white': editBankDetailsModal.selectedSection !== 'transaction' && hoverSection !== 'transaction',
                    }"
                    @mouseover="hoverSection = editBankDetailsModal.disableSubmit ? null : 'transaction'"
                    @mouseleave="hoverSection = null"
                    @click="selectBankSection('transaction')"
                    :style="{ cursor: editBankDetailsModal.disableSubmit ? 'default' : 'pointer' }"
                  >
                    <div class="d-flex justify-content-between mb-2">
                      <span class="font-weight-bold">Bank Name</span>
                      <span>
                        {{
                          editBankDetailsModal.transactiondata?.accno?.acc ||
                          'N/A'
                        }}
                      </span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span class="font-weight-bold">Account Number</span>
                      <span>
                        {{
                          editBankDetailsModal.transactiondata?.accno?.no ||
                          'N/A'
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <h6 class="mb-1">Beneficiary Level</h6>
                    </div>
                    <!-- <span class="text-muted small">Click to select</span> -->
                  </div>
                  <div
                    class="border rounded px-3 py-3 mb-4"
                    :class="{
                      'border-primary bg-light': editBankDetailsModal.selectedSection === 'beneficiary' || hoverSection === 'beneficiary',
                      'bg-white': editBankDetailsModal.selectedSection !== 'beneficiary' && hoverSection !== 'beneficiary',
                    }"
                    @mouseover="hoverSection = editBankDetailsModal.disableSubmit ? null : 'beneficiary'"
                    @mouseleave="hoverSection = null"
                    @click="selectBankSection('beneficiary')"
                    :style="{ cursor: editBankDetailsModal.disableSubmit ? 'default' : 'pointer' }"
                  >
                    <div v-if="editBankDetailsModal.bankdata.length === 0" class="text-muted">
                      No beneficiary Bank record found.
                    </div>
                    <div v-else-if="editBankDetailsModal.bankdata.length === 1">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="font-weight-bold">Bank Name</span>
                        <span>
                          {{
                            editBankDetailsModal.bankdata[0].bankName ||
                            'N/A'
                          }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">Account Number</span>
                        <span>
                          {{
                            editBankDetailsModal.bankdata[0].bankAccountNumber ||
                            'N/A'
                          }}
                        </span>
                      </div>
                    </div>
                    <div v-else class="beneficiary-scroll">
                      <div
                        v-for="(record, index) in editBankDetailsModal.bankdata"
                        :key="index"
                        class="border rounded mb-3 p-3"
                        :class="{
                          'bg-white': true,
                          'border-secondary': editBankDetailsModal.bankdata.length > 1,
                        }"
                      >
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <span class="font-weight-bold">Record {{ index + 1 }}</span>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                          <span class="font-weight-bold">Bank Name</span>
                          <span>
                            {{
                              record.bankName ||
                              'N/A'
                            }}
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <span class="font-weight-bold">Account Number</span>
                          <span>
                            {{
                              record.bankAccountNumber ||
                              'N/A'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="editBankDetailsModal.errorMessage" class="text-danger mb-3">
                  <h6>{{ editBankDetailsModal.errorMessage }}</h6>
                </div>
                <div class="d-flex justify-content-end">
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$bvModal.hide('editBankDetails')"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    v-if="!editBankDetailsModal.disableSubmit"
                    variant="primary ml-2 btn-mw"
                    size="lg"
                    :disabled="!editBankDetailsModal.selectedSection"
                    @click="submitEditBankDetails"
                  >
                    Submit
                  </b-button>
                </div>
              </div>
            </b-modal>

            <!-- ENG-2408: outcome of Verify Payment & Update Status. The endpoint answers
                 with `updated` plus a `message` either way, so this reports the outcome
                 rather than assuming a 200 means the status changed. -->
            <b-modal
              id="paymentReconcileResult"
              size="lg"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Payment Verification &mdash; {{ paymentReconcile.reference }}
                </h5>
              </template>
              <div class="modal-area px-3 py-2" v-if="paymentReconcile.result">
                <div
                  class="alert"
                  :class="'alert-' + reconcileOutcomeVariant(paymentReconcile.result)"
                >
                  <strong v-if="paymentReconcile.result.updated">
                    <i class="fa fa-check-circle mr-1"></i>
                  </strong>
                  {{ paymentReconcile.result.message }}
                </div>

                <div class="d-flex flex-wrap small text-muted mb-3">
                  <span class="mr-3">
                    Provider:
                    <strong class="text-capitalize">{{
                      paymentReconcile.result.provider || "n/a"
                    }}</strong>
                  </span>
                  <span class="mr-3">
                    Status: <strong>{{ paymentReconcile.result.current_status || "n/a" }}</strong>
                  </span>
                  <span class="mr-3">
                    Attempts checked:
                    <strong
                      >{{ paymentReconcile.result.attempts_checked }} of
                      {{ (paymentReconcile.result.attempts || []).length }}</strong
                    >
                  </span>
                </div>

                <div v-if="(paymentReconcile.result.attempts || []).length">
                  <h6 class="mb-2">Payment attempts</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered mb-0">
                      <thead>
                        <tr>
                          <th style="width: 1%"></th>
                          <th style="width: 34%">Payment reference</th>
                          <th>Outcome</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="attempt in paymentReconcile.result.attempts"
                          :key="attempt.payment_reference_id"
                        >
                          <td class="text-center">
                            <i
                              class="fa fa-check text-success"
                              v-if="attempt.accepted"
                              aria-hidden="true"
                            ></i>
                            <i class="fa fa-times text-muted" v-else aria-hidden="true"></i>
                          </td>
                          <td class="small" style="word-break: break-all">
                            {{ attempt.lookup_id || "no payment id recorded" }}
                          </td>
                          <td class="small" style="word-break: break-word; white-space: normal">
                            {{ attempt.message }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="d-flex justify-content-end mt-3">
                  <b-button
                    variant="primary btn-mw"
                    size="lg"
                    @click="$bvModal.hide('paymentReconcileResult')"
                    >Close</b-button
                  >
                </div>
              </div>
            </b-modal>


            <!-- ENG-2035: Send Reroute Request drawer (OPS CAN FIX path — MoMo & Bank).
                 Teleported to <body> via MountingPortal so this fixed overlay isn't trapped
                 in a transformed/scrolled ancestor (which caused ghost/double-paint flicker
                 on scroll). The slot still renders in this component's context. -->
            <MountingPortal v-if="rerouteDrawer.show" mountTo="body" append>
            <div class="reroute-drawer-wrap">
              <div class="reroute-drawer-overlay" @click="closeRerouteDrawer"></div>
              <!-- ENG-2035: spotlight — a transparent box over the clicked row whose huge
                   box-shadow dims the entire frame, leaving the real row visible + ringed.
                   Pure box-shadow, so it's cross-browser (no z-index on table rows). -->
              <div
                v-if="rerouteDrawer.spotlightRect"
                class="reroute-spotlight-hole"
                :style="rerouteSpotlightStyle()"
              ></div>
              <div class="reroute-drawer">
                <!-- Summary header -->
                <div class="reroute-drawer-header">
                  <div class="d-flex justify-content-between align-items-start">
                    <h5 class="text-primary font-weight-normal mb-0">Send Reroute Request</h5>
                    <button type="button" class="reroute-drawer-close" @click="closeRerouteDrawer">
                      &times;
                    </button>
                  </div>
                </div>

                <div class="reroute-drawer-body">
                  <!-- Summary card — scrolls with the content (like the mockup) -->
                  <div class="reroute-summary">
                    <div class="reroute-summary-row">
                      <span class="reroute-summary-label">Transaction Ref</span>
                      <span class="reroute-summary-val">{{ rerouteDrawer.item.custRefno }}</span>
                    </div>
                    <div class="reroute-summary-row">
                      <span class="reroute-summary-label">Current Status</span>
                      <span class="reroute-summary-val"><span class="reroute-badge reroute-badge--danger">Failed</span></span>
                    </div>
                    <div class="reroute-summary-row">
                      <span class="reroute-summary-label">Receiver</span>
                      <span class="reroute-summary-val">{{ rerouteDrawer.item.benificiary.name }}</span>
                    </div>
                    <div class="reroute-summary-row">
                      <span class="reroute-summary-label">Payment Method</span>
                      <span class="reroute-summary-val">
                        <template v-if="rerouteDrawer.channel === 'PM'">Mobile Money / {{ rerouteDrawer.before.network || '-' }}</template>
                        <template v-else>Bank Transfer / {{ rerouteDrawer.before.bank || '-' }}</template>
                      </span>
                    </div>
                    <div class="reroute-summary-row">
                      <span class="reroute-summary-label">Can Arch fix this?</span>
                      <span class="reroute-summary-val"><span class="reroute-badge reroute-badge--ok">Yes</span></span>
                    </div>
                  </div>

                  <!-- 1. What changed -->
                  <h6 class="reroute-section-title mt-4">1. What changed?</h6>
                  <div class="reroute-cards">
                    <div
                      class="reroute-card"
                      :class="{ active: rerouteDrawer.selectedCard === 'OPS_CAN_FIX' }"
                      @click="selectRerouteCard('OPS_CAN_FIX')"
                    >
                      <span class="reroute-cardpill reroute-cardpill--ops">OPS CAN FIX</span>
                      <div class="reroute-card-head">
                        <template v-if="rerouteDrawer.channel === 'PM'">Same receiver, wrong MoMo details</template>
                        <template v-else>Same receiver, wrong bank details</template>
                      </div>
                      <div class="reroute-card-desc">Use when only the payout details are incorrect.</div>
                    </div>
                    <div
                      class="reroute-card"
                      :class="{ active: rerouteDrawer.selectedCard === 'APPROVAL' }"
                      @click="selectRerouteCard('APPROVAL')"
                    >
                      <span class="reroute-cardpill reroute-cardpill--approval">APPROVAL</span>
                      <div class="reroute-card-head">Same receiver, name typo</div>
                      <div class="reroute-card-desc">Use for a spelling or name-order mismatch.</div>
                    </div>
                    <div class="reroute-card disabled">
                      <span class="reroute-cardpill reroute-cardpill--transfer">NEW TRANSFER</span>
                      <div class="reroute-card-head">Same receiver, different method</div>
                      <div class="reroute-card-desc">Use when MoMo changes to bank, or bank to MoMo.</div>
                      <span class="reroute-soon">Coming soon</span>
                    </div>
                    <div class="reroute-card disabled">
                      <span class="reroute-cardpill reroute-cardpill--customer">CUSTOMER ONLY</span>
                      <div class="reroute-card-head">Different receiver</div>
                      <div class="reroute-card-desc">Ops cannot change who receives the money.</div>
                      <span class="reroute-soon">Coming soon</span>
                    </div>
                  </div>

                  <!-- 2. Arch safety check (read-only, representational placeholder) -->
                  <h6 class="reroute-section-title mt-4">2. Arch safety check</h6>
                  <div class="reroute-safety">
                    <div class="reroute-safety-row">
                      <span class="reroute-safety-label">Receiver changed?</span>
                      <span class="reroute-safety-val">No</span>
                    </div>
                    <div class="reroute-safety-row">
                      <span class="reroute-safety-label">Payment method changed?</span>
                      <span class="reroute-safety-val">No</span>
                    </div>
                    <div class="reroute-safety-row">
                      <span class="reroute-safety-label">Sent to partner yet?</span>
                      <span class="reroute-safety-val">No</span>
                    </div>
                    <div class="reroute-safety-row">
                      <span class="reroute-safety-label">Payout locked?</span>
                      <span class="reroute-safety-val">No</span>
                    </div>
                  </div>
                  <div class="reroute-banner mt-3">
                    <template v-if="rerouteDrawer.selectedCard === 'APPROVAL'">
                      <div class="reroute-banner-title">Recommended action: Correct the receiver name</div>
                      <div class="reroute-banner-sub">
                        This sends a name correction for checker approval. The payout won't retry until it's approved.
                      </div>
                    </template>
                    <template v-else>
                      <div class="reroute-banner-title">Recommended action: Fix payout details</div>
                      <div class="reroute-banner-sub">
                        Arch will correct the number/account for this transfer only. The receiver stays the same.
                      </div>
                    </template>
                  </div>

                  <!-- 3. OPS CAN FIX form -->
                  <template v-if="rerouteDrawer.selectedCard === 'OPS_CAN_FIX'">
                    <h6 class="reroute-section-title mt-4">3. Correction details</h6>

                    <div class="reroute-form-box">
                    <!-- Reason -->
                    <div class="reroute-field">
                      <label class="reroute-label">Why are we fixing this? <span class="reroute-req">*</span></label>
                      <multiselect
                        placeholder="Select a reason"
                        v-model="rerouteDrawer.reasonCode"
                        :show-labels="false"
                        :options="rerouteReasonOptions[rerouteDrawer.channel]"
                      ></multiselect>
                    </div>

                    <!-- MoMo (PM) -->
                    <template v-if="rerouteDrawer.channel === 'PM'">
                      <div class="reroute-field">
                        <label class="reroute-label">Mobile Network <span class="reroute-req">*</span></label>
                        <multiselect
                          placeholder="Select network"
                          v-model="rerouteDrawer.network"
                          :show-labels="false"
                          :options="network_options"
                          label="name"
                          track-by="id"
                        ></multiselect>
                      </div>
                      <div class="reroute-field">
                        <label class="reroute-label">Mobile Number <span class="reroute-req">*</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.phoneNumber"
                          class="form-control"
                          placeholder="Full number including country code"
                          @keydown="restrictMobileNumberCharacter($event)"
                        />
                        <button
                          v-if="isRerouteNumberChanged()"
                          type="button"
                          class="reroute-checkname-btn"
                          @click="openRerouteNameCheck()"
                        >
                          Check name
                        </button>
                      </div>
                    </template>

                    <!-- Bank (PA) -->
                    <template v-else>
                      <div class="reroute-field">
                        <label class="reroute-label">Bank Name <span class="reroute-req">*</span></label>
                        <multiselect
                          placeholder="Select bank"
                          v-model="rerouteDrawer.bank"
                          :show-labels="false"
                          :options="bank_options"
                          label="name"
                          track-by="id"
                        ></multiselect>
                      </div>
                      <div class="reroute-field">
                        <label class="reroute-label">Account Number <span class="reroute-req">*</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.account"
                          class="form-control"
                          placeholder="Enter account number"
                          @keydown="restrictSpecialCharacter($event)"
                        />
                        <button
                          v-if="isRerouteNumberChanged()"
                          type="button"
                          class="reroute-checkname-btn"
                          @click="openRerouteNameCheck()"
                        >
                          Check name
                        </button>
                      </div>
                    </template>

                    <!-- Optional ticket + notes -->
                    <div class="reroute-field">
                      <label class="reroute-label">Ticket / Case Reference <span class="reroute-opt">(optional)</span></label>
                      <input
                        type="text"
                        v-model="rerouteDrawer.evidenceRef"
                        class="form-control"
                        placeholder="Enter support ticket or call reference"
                      />
                    </div>
                    <div class="reroute-field">
                      <label class="reroute-label">Notes <span class="reroute-opt">(optional)</span></label>
                      <textarea
                        v-model="rerouteDrawer.notes"
                        class="form-control"
                        maxlength="250"
                        rows="3"
                        placeholder="Explain what the customer confirmed..."
                      ></textarea>
                    </div>
                    </div>

                    <!-- Before / After -->
                    <div class="reroute-beforeafter mt-2">
                      <div class="reroute-ba-col">
                        <div class="reroute-ba-head">Before</div>
                        <template v-if="rerouteDrawer.channel === 'PM'">
                          <div>Network: {{ rerouteDrawer.before.network || '-' }}</div>
                          <div>Number: {{ rerouteDrawer.before.phoneNumber || '-' }}</div>
                        </template>
                        <template v-else>
                          <div>Bank: {{ rerouteDrawer.before.bank || '-' }}</div>
                          <div>Account: {{ rerouteDrawer.before.account || '-' }}</div>
                        </template>
                      </div>
                      <div class="reroute-ba-col">
                        <div class="reroute-ba-head">After</div>
                        <template v-if="!rerouteHasChange()">
                          <div class="text-muted">No change yet</div>
                        </template>
                        <template v-else-if="rerouteDrawer.channel === 'PM'">
                          <div>Network: {{ (rerouteDrawer.network && rerouteDrawer.network.name) || '-' }}</div>
                          <div>Number: {{ rerouteDrawer.phoneNumber || '-' }}</div>
                        </template>
                        <template v-else>
                          <div>Bank: {{ (rerouteDrawer.bank && rerouteDrawer.bank.name) || '-' }}</div>
                          <div>Account: {{ rerouteDrawer.account || '-' }}</div>
                        </template>
                      </div>
                    </div>
                  </template>

                  <!-- 3. APPROVAL form — name correction (ENG-2036) -->
                  <template v-else>
                    <h6 class="reroute-section-title mt-4">3. Correction details</h6>

                    <div class="reroute-form-box">
                      <div class="reroute-field">
                        <label class="reroute-label">First Name <span class="reroute-req">*</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.firstName"
                          class="form-control"
                          placeholder="Enter first name"
                        />
                      </div>
                      <div class="reroute-field">
                        <label class="reroute-label">Middle Name <span class="reroute-opt">(optional)</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.middleName"
                          class="form-control"
                          placeholder="Enter middle name"
                        />
                      </div>
                      <div class="reroute-field">
                        <label class="reroute-label">Last Name <span class="reroute-req">*</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.lastName"
                          class="form-control"
                          placeholder="Enter last name"
                        />
                      </div>

                      <!-- Optional ticket + notes -->
                      <div class="reroute-field">
                        <label class="reroute-label">Ticket / Case Reference <span class="reroute-opt">(optional)</span></label>
                        <input
                          type="text"
                          v-model="rerouteDrawer.evidenceRef"
                          class="form-control"
                          placeholder="Enter support ticket or call reference"
                        />
                      </div>
                      <div class="reroute-field">
                        <label class="reroute-label">Notes <span class="reroute-opt">(optional)</span></label>
                        <textarea
                          v-model="rerouteDrawer.notes"
                          class="form-control"
                          maxlength="250"
                          rows="3"
                          placeholder="Explain what the customer confirmed..."
                        ></textarea>
                      </div>
                    </div>

                    <!-- Before / After -->
                    <div class="reroute-beforeafter mt-2">
                      <div class="reroute-ba-col">
                        <div class="reroute-ba-head">Before</div>
                        <div>Name: {{ rerouteFullName(rerouteDrawer.before) }}</div>
                      </div>
                      <div class="reroute-ba-col">
                        <div class="reroute-ba-head">After</div>
                        <template v-if="!rerouteHasChange()">
                          <div class="text-muted">No change yet</div>
                        </template>
                        <template v-else>
                          <div>Name: {{ rerouteFullName(rerouteDrawer) }}</div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>

                <!-- Footer -->
                <div class="reroute-drawer-footer">
                  <b-button variant="secondary btn-mw" size="lg" @click="closeRerouteDrawer">
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary ml-md-1 btn-mw"
                    size="lg"
                    :disabled="rerouteSubmitDisabled()"
                    @click="submitRerouteRequest"
                  >
                    Submit
                  </b-button>
                </div>
              </div>
              <!-- ENG-2058: read-only name-check result. Rendered INSIDE the drawer portal so it
                   stacks above the drawer and is removed when the drawer closes (no orphan modal). -->
              <div
                v-if="rerouteNameCheckShow"
                class="reroute-namecheck-overlay"
                @click.self="rerouteNameCheckShow = false"
              >
                <div class="reroute-namecheck-card">
                  <div class="reroute-namecheck-head">
                    <span>Name Verification</span>
                    <button
                      type="button"
                      class="reroute-drawer-close"
                      @click="rerouteNameCheckShow = false"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="reroute-namecheck-body">
                    <div class="reroute-namecheck-label">Account Name</div>
                    <div v-if="rerouteCheckedName" class="reroute-namecheck-name">
                      {{ rerouteCheckedName }}
                    </div>
                    <div v-else class="reroute-namecheck-msg">
                      No name found for the provided number/account.
                    </div>
                  </div>
                  <div class="reroute-namecheck-foot">
                    <button
                      type="button"
                      class="reroute-checkname-btn"
                      @click="rerouteNameCheckShow = false"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </MountingPortal>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go to Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
            <!--<div class="mt-5">
              <strong>Total Number of Transactions:4</strong>
              <span class="d-block"
                ><strong>NOTE:</strong>The number of transactions in the report
                is limited to 100</span
              >
              <div class="d-block d-md-flex justify-content-between w-50 mb-4">
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Remitter to Pay</span>
                  <span>AUD 4350.19</span>
                </div>
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Total Source Amount</span>
                  <span>AUD 4350.19</span>
                </div>
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Commission</span>
                  <span>AUD 4350.19</span>
                </div>
              </div>
              <div class="d-flex flex-column mb-4 mt-4">
                <span class="font-weight-bold">Total Deduction</span>
                <span>AUD 4350.19</span>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bold">Total Dest Amount</span>
                <span>AUD 4350.19</span>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="show-details"
      size="lg"
      class="transaction-lg-modal"
      title="Transaction Details"
      hide-footer
      no-stacking
      no-close-on-backdrop
    >
      <div v-if="detailsstatus" class="modal-area">
        <div class="transaction-details-body">
          <h6 class="text-danger">{{ errorMsg }}</h6>
        </div>
      </div>
      <div v-if="!detailsstatus" class="modal-area">
        <div class="row">
          <div class="col-md-6">
            <ul class="list-unstyled mb-0 mr-2">
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Sender Name:</span>
                  <span class="ml-2">{{ transactionDetail.sendername }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Merchant Ref. No.:</span>
                  <span class="ml-2">{{ transactionDetail.refno }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Source Amount:</span>
                  <span class="ml-2">{{ transactionDetail.srcamount }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Transaction Status:</span>
                  <span class="ml-2">{{ transactionDetail.transStatus }}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled mb-0">
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Beneficiary Name:</span>
                  <span class="ml-2">
                    {{ transactionDetail.beneficiaryname }}
                  </span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Account No.:</span>
                  <span class="ml-2">
                    {{ transactionDetail.accName }} /
                    {{ transactionDetail.accNumber }}
                  </span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Dest. Amount:</span>
                  <span class="ml-2">{{ transactionDetail.destamount }}</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div class="transaction-raw-details-body max-width">
          <ul
            class="list-unstyled mb-0"
            v-for="item in this.transactionDetail.details"
            :key="item.id"
          >
            <!-- <span>{{item.transactionDate}}</span> -->
            <span v-if="item.transactionDate">
              <li>
                <p class="mb-0 font-12 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Trans. ID:</span>
                  <span class="ml-2">{{ item.transactionid }}</span>
                </p>
              </li>
              <li>
                <p class="mb-0 font-12 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Provider Name:</span>
                  <span class="ml-2 badge-danger">
                    {{ item.provider_name }}
                  </span>
                </p>
              </li>
              <!-- <li class="mb-2">
                                <p class="mb-0 font-12 d-flex align-items-center">
                                    <span class="font-weight-bold w-30">Trans. Status:</span>
                                    <span class="ml-2" v-if="item.status == '0'">Initial Request</span>
                                    <span class="ml-2" v-if="item.status == '1'">Callback Pending</span>
                                    <span class="ml-2" v-if="item.status == '2'">Success</span>
                                    <span class="ml-2" v-if="item.status == '3'">Failed</span>
                                    <span class="ml-2" v-if="item.status == '4'">Callback Failed</span>
                                    <span class="ml-2" v-if="item.status == '5'">Callback Success</span>
                                </p>
                            </li> -->
              <span
                v-if="
                  item.provider_name != 'Terrapay' ||
                  item.terrapay_reqs.length == 0
                "
              >
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Trans. Date:</span>
                    <span class="ml-2">
                      {{ convertDate(item.transactionDate) }}
                    </span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Request Date:</span>
                    <span class="ml-2">{{ convertDate(item.createdAt) }}</span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Raw Request:</span>
                    <span class="ml-2 scroll" v-if="item.raw_request">
                      {{ item.raw_request }}
                      <button
                        @click="copyValue(item.raw_request)"
                        title="copy to clipboard"
                      >
                        <i class="fa fa-copy"></i>
                      </button>
                    </span>
                    <span class="ml-2" v-if="!item.raw_request">N/A</span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Response Date:</span>
                    <span class="ml-2">{{ convertDate(item.updatedAt) }}</span>
                  </p>
                </li>
                <li>
                  <!-- class="py-3" -->
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Response:</span>
                    <span
                      class="ml-2 scroll"
                      :class="[
                        item.providerResponse.error ? 'badge-danger' : '',
                      ]"
                      v-if="item.providerResponse"
                    >
                      {{ convertToString(item.providerResponse) }}
                      <button
                        @click="copyValue(item.providerResponse)"
                        title="copy to clipboard"
                      >
                        <i class="fa fa-copy"></i>
                      </button>
                    </span>
                    <span class="ml-2" v-if="!item.providerResponse">N/A</span>
                  </p>
                </li>
              </span>
              <span
                v-if="
                  item.provider_name == 'Terrapay' &&
                  item.terrapay_reqs.length != 0
                "
              >
                <!-- <h6 v-if="item.terrapay_reqs.length == 0">Not Available</h6> -->
                <span
                  v-for="terrapay in item.terrapay_reqs"
                  :key="terrapay.transaction_ref"
                >
                  <li>
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Trans. Date:</span>
                      <span class="ml-2">
                        {{ convertDate(terrapay.created_at) }}
                      </span>
                    </p>
                  </li>
                  <li>
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Raw Request:</span>
                      <span class="ml-2 scroll" v-if="terrapay.raw_request">
                        {{ terrapay.raw_request }}
                        <button
                          @click="copyValue(terrapay.raw_request)"
                          title="copy to clipboard"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                      </span>
                      <span class="ml-2" v-if="!terrapay.raw_request">N/A</span>
                    </p>
                  </li>
                  <li class="py-3">
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Response:</span>
                      <span
                        class="ml-2 scroll"
                        :class="[
                          terrapay.raw_response.error ? 'badge-danger' : '',
                        ]"
                        v-if="terrapay.raw_response"
                      >
                        {{ convertToString(terrapay.raw_response) }}
                        <button
                          @click="copyValue(terrapay.raw_response)"
                          title="copy to clipboard"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                      </span>
                      <span class="ml-2" v-if="!terrapay.raw_response">
                        N/A
                      </span>
                    </p>
                  </li>
                </span>
              </span>
              <hr />
            </span>
          </ul>
        </div>
      </div>
    </b-modal>
    <CustomerDetailsModel :customerid="customerDetail" />
    <RefundRemitterCredit :remitterCredit="remitterCredit" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
// const { VueTelInput } = require("vue-tel-input");
import parsePhoneNumber from "libphonenumber-js";
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "vue-select/dist/vue-select.css";
import "@/assets/css/reroute-drawer.css";
// ENG-2035: render the reroute drawer at <body> level. As a position:fixed overlay nested
// deep inside the scrolled/transformed content shell it ghosts/double-paints on scroll
// (GPU compositing); teleporting it to body — same as bootstrap-vue modals — fixes that.
import { MountingPortal } from "portal-vue";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import RefundRemitterCredit from "../../core/RefundRemitterCredit.vue";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
const moment = require("moment");
import Multiselect from "vue-multiselect";
import shared from "@/shared.js";
import {
  GET_TRANSACTION_LIST,
  GET_PROVIDER_LIST,
  PROCESS_TRANSACTIONS,
  UPDATE_PAYOUT_STATUS,
  GET_TRANSACTION_STATUS,
  UPDATE_TRANSACTION_STATUS,
  MANUAL_SUCCESS_TRANSACTION,
  MANUAL_FAIL_TRANSACTION,
  TRANSACTION_MOMO_NETWORKS,
  TRANSACTION_PAYMENT_CAPTURE,
  RECONCILE_PAYMENT_STATUS,
  CHECK_TRANSACTION_STATUS,
  UPDATE_TRANSACTION_MOMO_NUMBER,
  TRANSACTION_BANK_LIST,
  UPDATE_TRANSACTION_BANK_ACCOUNT,
  COUNTRYLIST,
  GET_ALL_PAYMENT_METHODS,
  GET_TRANSACTION_MOMO_BANK_DETAIL,
  UPDATE_TRANSACTION_BANK_MOMO_DETAILS,
  GET_BLOCKED_ENTITIES,
  SUBMIT_RECOVERY_ACTION,
  NAME_CHECK_PROPOSED_ACCOUNT,
  GET_LINKED_RISK_BATCH,
  GET_RECEIVER_RISK_BATCH,
} from "../../../store/actions.type.js";
import { mapGetters } from "vuex";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "MiddlewareTransactionListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    "v-select": () => import("vue-select"),
    Multiselect,
    // VueTelInput,
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
    RefundRemitterCredit,
    ValidationObserver,
    ValidationProvider,
    MountingPortal,
  },
  methods: {
    // Filter payout options based on reference number and transaction details
    // ENG-1996: a row is locked for forward-processing while it has one or more reroute
    // corrections awaiting approval (backend returns them in pendingReroutes, newest-first).
    hasPendingReroute(item) {
      return Array.isArray(item?.pendingReroutes) && item.pendingReroutes.length > 0;
    },
    formatRerouteTime(submittedAt) {
      // moment renders in the browser's local timezone (submittedAt is UTC from the API).
      // Compact format (e.g. "26th Jun 2026, 2:32 PM") so the popover line fits without wrapping.
      return submittedAt ? moment(submittedAt).format("Do MMM YYYY, h:mm A") : "";
    },
    // ENG-1996: turn the server-derived correction_fields codes into operator-friendly labels.
    // Falls back to the raw code (spaces for underscores) for any field we don't have a label for.
    rerouteFieldsLabel(fields) {
      const labels = {
        mobile_number: "Mobile number",
        mobile_network: "Network",
        beneficiary_name: "Name",
        bank_id: "Bank",
        account_number: "Account number",
        // ENG-2069: dispatch attempt-count guard raises this request type; amount_limit is no
        // longer produced by the backend (out-of-limit changes are now plain pending approvals).
        dispatch_approval: "Dispatch approval",
      };
      return (fields || [])
        .map((field) => labels[field] || (field || "").replace(/_/g, " "))
        .join(", ");
    },
    // ENG-1996: reroute only applies to payout corrections, identified by the reference_id
    // prefix — PM (Mobile Money) or PA (Bank Transfer). Anything else (e.g. PW wallet) is
    // out of scope, so the Reroute action is hidden for it.
    isReroutableReference(item) {
      const ref = (item?.custRefno || item?.reference_number || "")
        .toString()
        .trim()
        .toUpperCase();
      return ref.startsWith("PM") || ref.startsWith("PA");
    },
    // ENG-2035: entry point for the maker to submit a Reroute Request. Opens the in-place
    // drawer over the list (Option A) and prepopulates the OPS CAN FIX form from the row.
    async rerouteAction(item, rowIndex) {
      if (!item?.destcountry || !item.destcountry.countryid) {
        myFunction.showInfo("Destination country information is missing", "error");
        return;
      }
      const ref = (item.custRefno || "").toString().trim().toUpperCase();
      const channel = ref.startsWith("PA") ? "PA" : "PM";

      // reset drawer state
      this.rerouteDrawer.rowIndex = typeof rowIndex === "number" ? rowIndex : -1;
      this.rerouteDrawer.spotlightRect = null;
      this.rerouteDrawer.item = item;
      this.rerouteDrawer.channel = channel;
      this.rerouteDrawer.selectedCard = "OPS_CAN_FIX";
      this.rerouteDrawer.reasonCode = "";
      this.rerouteDrawer.evidenceRef = "";
      this.rerouteDrawer.notes = "";
      this.rerouteDrawer.network = "";
      this.rerouteDrawer.phoneNumber = "";
      this.rerouteDrawer.countryCode = item.destcountry.mobilecountrycode || "";
      this.rerouteDrawer.bank = "";
      this.rerouteDrawer.account = "";
      this.rerouteDrawer.firstName = item.receiverFirstName || "";
      this.rerouteDrawer.middleName = item.receiverMiddleName || "";
      this.rerouteDrawer.lastName = item.receiverLastName || "";
      this.rerouteDrawer.submitting = false;

      if (channel === "PM") {
        await this.getAllMobilenetworks(item.destcountry.countryid);
        this.rerouteDrawer.network =
          this.network_options.filter((n) => n.name === item.accno.acc)[0] || "";
        // ENG-2423: prefill the stored number verbatim, country code included, so a wrong
        // country code is visible and correctable — splitting it off and re-deriving the
        // prefix from the destination country hid the defect and excluded it from the diff.
        const storedNumber =
          item.accno.no && item.accno.no !== "-" ? item.accno.no.trim() : "";
        this.rerouteDrawer.phoneNumber = storedNumber;
        this.rerouteDrawer.before = {
          network: this.rerouteDrawer.network ? this.rerouteDrawer.network.name : "",
          phoneNumber: storedNumber,
          bank: "",
          account: "",
          firstName: item.receiverFirstName || "",
          middleName: item.receiverMiddleName || "",
          lastName: item.receiverLastName || "",
        };
      } else {
        await this.getCountryWiseBank(item.destcountry.countryid);
        this.rerouteDrawer.bank =
          this.bank_options.filter((b) => b.name === item.accno.acc)[0] || "";
        this.rerouteDrawer.account =
          item.accno.no && item.accno.no !== "-" ? item.accno.no : "";
        this.rerouteDrawer.before = {
          network: "",
          phoneNumber: "",
          bank: this.rerouteDrawer.bank ? this.rerouteDrawer.bank.name : "",
          account: this.rerouteDrawer.account,
          firstName: item.receiverFirstName || "",
          middleName: item.receiverMiddleName || "",
          lastName: item.receiverLastName || "",
        };
      }
      this.rerouteDrawer.show = true;
      // Lock the page scroll so only the drawer scrolls (no double scrollbar), then
      // position the spotlight over the clicked row once it's painted and keep it aligned
      // on resize.
      document.documentElement.classList.add("reroute-drawer-open");
      document.body.classList.add("reroute-drawer-open");
      this.$nextTick(() => {
        this.updateRerouteSpotlight();
        window.addEventListener("resize", this.updateRerouteSpotlight);
      });
    },
    closeRerouteDrawer() {
      this.rerouteDrawer.show = false;
      this.rerouteDrawer.item = null;
      this.rerouteDrawer.spotlightRect = null;
      this.rerouteNameCheckShow = false;
      this.rerouteCheckedName = "";
      document.documentElement.classList.remove("reroute-drawer-open");
      document.body.classList.remove("reroute-drawer-open");
      window.removeEventListener("resize", this.updateRerouteSpotlight);
    },
    // ENG-2035: measure the clicked row and store its viewport rect; the spotlight box is
    // positioned over it (fixed) and its box-shadow dims the rest of the frame.
    updateRerouteSpotlight() {
      if (!this.rerouteDrawer.show) return;
      const table = this.$refs.transactionTable;
      const rows =
        table && table.$el ? table.$el.querySelectorAll("tbody > tr") : [];
      const row = rows[this.rerouteDrawer.rowIndex];
      if (!row) {
        this.rerouteDrawer.spotlightRect = null;
        return;
      }
      const r = row.getBoundingClientRect();
      this.rerouteDrawer.spotlightRect = {
        top: r.top,
        left: r.left,
        width: r.width,
        height: r.height,
      };
    },
    // Inline style for the spotlight box from the measured rect.
    rerouteSpotlightStyle() {
      const r = this.rerouteDrawer.spotlightRect;
      if (!r) return {};
      return {
        top: `${r.top}px`,
        left: `${r.left}px`,
        width: `${r.width}px`,
        height: `${r.height}px`,
      };
    },
    // Join first/middle/last into a display name for the name Before/After panel.
    rerouteFullName(src) {
      return [src.firstName, src.middleName, src.lastName]
        .map((part) => (part || "").trim())
        .filter(Boolean)
        .join(" ") || "-";
    },
    selectRerouteCard(card) {
      // NEW_TRANSFER and CUSTOMER_ONLY are "Coming soon" — not selectable.
      if (card !== "OPS_CAN_FIX" && card !== "APPROVAL") return;
      this.rerouteDrawer.selectedCard = card;
    },
    // Lenient client-side change detection — the backend 422 (E1013-016) is the real
    // no-change guard. Submit is enabled only when a field textually differs from the
    // prepopulated value.
    rerouteHasChange() {
      const d = this.rerouteDrawer;
      if (d.selectedCard === "APPROVAL") {
        return (
          (d.firstName || "").trim() !== (d.before.firstName || "").trim() ||
          (d.middleName || "").trim() !== (d.before.middleName || "").trim() ||
          (d.lastName || "").trim() !== (d.before.lastName || "").trim()
        );
      }
      if (d.channel === "PM") {
        const networkChanged =
          (d.network && d.network.name ? d.network.name : "") !== d.before.network;
        const numberChanged = (d.phoneNumber || "").trim() !== (d.before.phoneNumber || "").trim();
        return networkChanged || numberChanged;
      }
      const bankChanged = (d.bank && d.bank.name ? d.bank.name : "") !== d.before.bank;
      const accountChanged = (d.account || "").trim() !== (d.before.account || "").trim();
      return bankChanged || accountChanged;
    },
    rerouteSubmitDisabled() {
      const d = this.rerouteDrawer;
      if (d.submitting) return true;
      if (d.selectedCard === "APPROVAL") {
        // First + Last required (middle optional); backend E1013-017 is the real guard.
        if (!(d.firstName || "").trim() || !(d.lastName || "").trim()) return true;
        return !this.rerouteHasChange();
      }
      if (!d.reasonCode) return true;
      return !this.rerouteHasChange();
    },
    // ENG-2423: the field holds the full international number, so the corrected value is the
    // typed value. The duplicate-country-code guards are gone with the prefix that caused them;
    // the backend normalises to E.164 and rejects a number that is not valid for the
    // destination country (E1013-009).
    buildRerouteMobileNumber() {
      return (this.rerouteDrawer.phoneNumber || "").trim();
    },
    // ENG-2058: show the "Check name" button only when the proposed number/account differs from
    // the prepopulated value (network/bank-only changes don't trigger it).
    isRerouteNumberChanged() {
      const d = this.rerouteDrawer;
      if (d.channel === "PM") {
        const n = (d.phoneNumber || "").trim();
        return n !== "" && n !== (d.before.phoneNumber || "").trim();
      }
      const a = (d.account || "").trim();
      return a !== "" && a !== (d.before.account || "").trim();
    },
    // ENG-2423: digits of the international form. The number is now entered free-form, so a
    // locally formatted entry (0205…) must still reach the partner as 233205… — which the fixed
    // "+233" prefix used to guarantee. Falls back to the digits as typed when it can't be parsed,
    // so a lookup is still attempted rather than silently skipped.
    rerouteNameCheckDigits(fullNumber, isoCode) {
      try {
        const parsed = parsePhoneNumber(fullNumber, (isoCode || "").toUpperCase());
        if (parsed && parsed.isValid()) {
          return parsed.number.replace(/\D/g, "");
        }
      } catch (error) {
        // fall through to the digits as typed
      }
      return fullNumber.replace(/\D/g, "");
    },
    // ENG-2058: manual, display-only name-check of the PROPOSED account (ENG-2056 endpoint). Shows
    // the returned account-holder name in a read-only modal; never blocks the form — "no name found"
    // is shown gracefully.
    async openRerouteNameCheck() {
      const d = this.rerouteDrawer;
      const isMomo = d.channel === "PM";
      let accountNumber = "";
      if (isMomo) {
        const full = this.buildRerouteMobileNumber();
        if (!full) return; // nothing entered yet
        accountNumber = this.rerouteNameCheckDigits(
          full,
          (d.item && d.item.destcountry && d.item.destcountry.isocode) || "",
        );
      } else {
        accountNumber = (d.account || "").trim();
      }
      const payload = {
        isocode: (d.item && d.item.destcountry && d.item.destcountry.isocode) || "",
        payoutType: isMomo ? "Mobile Money" : "Bank Deposit",
        accountNumber,
        networkOrBankName: isMomo
          ? (d.network && d.network.name) || ""
          : (d.bank && d.bank.name) || "",
      };
      this.rerouteCheckedName = "";
      try {
        const response = await this.$store.dispatch(NAME_CHECK_PROPOSED_ACCOUNT, payload);
        const name =
          response && response.status == 200 && response.data && response.data.details
            ? response.data.details.name
            : "";
        this.rerouteCheckedName = name || "";
      } catch (error) {
        this.rerouteCheckedName = "";
      }
      // show the result overlay only after the lookup completes (the global loader covers the wait)
      this.rerouteNameCheckShow = true;
    },
    submitRerouteRequest() {
      const d = this.rerouteDrawer;
      let correctedValues = {};
      let actionType = "";
      let reasonCode = d.reasonCode;
      if (d.selectedCard === "APPROVAL") {
        // Name correction — always PENDING_APPROVAL, no name-check (NOT_APPLICABLE).
        actionType = "NAME_CORRECTION";
        reasonCode = "Name Correction";
        correctedValues = {
          first_name: (d.firstName || "").trim(),
          middle_name: (d.middleName || "").trim(),
          last_name: (d.lastName || "").trim(),
        };
      } else if (d.channel === "PM") {
        actionType = "REROUTE_MOMO";
        const fullNumber = this.buildRerouteMobileNumber();
        if (fullNumber === null) return;
        correctedValues = {
          mobile_number: fullNumber,
          mobile_network: d.network && d.network.id ? d.network.id : "",
        };
      } else {
        actionType = "REROUTE_BANK";
        correctedValues = {
          bank_account_number: (d.account || "").trim(),
          bank_id: d.bank && d.bank.id ? d.bank.id : "",
        };
      }
      const params = {
        transactionId: d.item.id,
        actionType,
        reasonCode,
        correctedValues,
        evidenceRef: (d.evidenceRef || "").trim() || undefined,
        notes: (d.notes || "").trim() || undefined,
      };
      d.submitting = true;
      this.$store
        .dispatch(SUBMIT_RECOVERY_ACTION, params)
        .then((response) => {
          d.submitting = false;
          if (response && response.status === 201) {
            myFunction.showInfo(this.rerouteSuccessMessage(response.data, actionType), "success");
            this.closeRerouteDrawer();
            // Option A: already on the list — refresh in place, preserving filters/page.
            this.getTransactionList();
          } else {
            // Surface the backend message verbatim; keep the drawer open to adjust.
            const msg =
              (response && response.data && response.data.message) ||
              "Failed to submit the reroute request. Please try again.";
            myFunction.showInfo(msg, "error");
          }
        });
    },
    // Status-aware success copy driven by the response, not the selected card. An out-of-limit
    // low-risk change now returns PENDING_APPROVAL (ENG-2067), so it falls through to the standard
    // pending-approval message — there is no separate amount-limit rider any more (ENG-2069).
    rerouteSuccessMessage(data, actionType) {
      const status = data && data.status;
      const changedFields = (data && data.changedFields) || [];
      // Pure name correction (APPROVAL) — always PENDING; the name IS the change, so the
      // "also updated from partner record" rider (an identifier-fold signal) doesn't apply.
      if (actionType === "NAME_CORRECTION") {
        return "Name correction submitted for checker approval; the payout won't retry until it's approved.";
      }
      if (status === "SYSTEM_APPROVED") {
        return "Reroute applied to this transaction.";
      }
      // PENDING_APPROVAL
      if (changedFields.includes("beneficiary_name")) {
        return "Reroute submitted for checker approval; the payout won't retry until it's approved. The beneficiary name was also updated to match the partner's account record.";
      }
      return "Reroute submitted for checker approval; the payout won't retry until it's approved.";
    },
    getFilteredPayoutOptions(item) {
      // Handle backward compatibility - if item is a string (old usage), treat as reference number
      const referenceNumber = typeof item === 'string' ? item : item?.custRefno;
      const sourceCurrency = typeof item === 'object' ? item?.sourceCurrencyCode : null;
      const paymentMethodId = typeof item === 'object' ? item?.paymentMethodId : null;
      const transactionStatus = typeof item === 'object' ? item?.status?.name : null;

      // Check for EUR currency with specific payment method and Awaiting Funds status - show only "Funds Received"
      if (sourceCurrency === 'EUR' &&
          paymentMethodId === this.EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID &&
          transactionStatus === this.EUR_FUNDS_RECEIVED_STATUS) {
        // Return custom "Funds Received" option
        return [{
          name: 'Funds Received',
          providerid: 'FUNDS_RECEIVED_STATUS',
          id: 'FUNDS_RECEIVED_STATUS'
        }];
      }

      // If reference number starts with 'PW', show only 'Wallet' option regardless of status
      if (referenceNumber && referenceNumber.startsWith('PW')) {
        return this.payoutoption.filter(option =>
          option.name && option.name.toLowerCase().includes('wallet')
        );
      }

      // Otherwise, show all payout options
      return this.payoutoption;
    },
    mobileInputValidate(phoneObject) {
      this.mobileInputError = phoneObject.valid;
    },
    restrictSpecialCharacter(e) {
      if (
        /[^0-9]/.test(e.key) &&
        !["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
    },
    // ENG-2423: the reroute number is entered in full international form, so "+" has to be
    // typeable. restrictSpecialCharacter allows digits only and is left alone for its own callers.
    restrictMobileNumberCharacter(e) {
      if (
        /[^0-9+]/.test(e.key) &&
        !["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
    },
    handlePhonePaste(e) {
      // Prevent default paste behavior
      e.preventDefault();

      // Get pasted text from clipboard
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');

      // Strip leading + if it exists
      const cleanedText = pastedText.replace(/^\+/, '');

      // Get the input element
      const input = e.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // Get current value
      const currentValue = this.updateMobile.phoneNumber || '';

      // Insert cleaned text at cursor position
      const newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);

      // Update the v-model
      this.updateMobile.phoneNumber = newValue;

      // Set cursor position after pasted text
      this.$nextTick(() => {
        input.setSelectionRange(start + cleanedText.length, start + cleanedText.length);
      });
    },
    // get All Mobile netowrks
    async getAllMobilenetworks(country_id) {
      // momo/provider-list?countryid=8ee2b557-1047-49c4-bac2-ee7bf35e24e3&currency=GHS
      let params = `?countryid=${country_id}`;
      this.network_options = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.network_options = response.data.details;
          }
        });
    },
    // edit mobile network for single transaction
    async mobileNetworkEdit(data) {
      // Check if destination country data exists
      if (!data.destcountry || !data.destcountry.countryid) {
        myFunction.showInfo("Destination country information is missing", "error");
        return;
      }

      await this.getAllMobilenetworks(data.destcountry.countryid);
      this.updateMobile.id = data.id;
      this.updateMobile.countryCode = data.destcountry.mobilecountrycode;
      this.updateMobile.network = this.network_options.filter(
        (item) => item.name === data.accno.acc,
      )[0];
      this.updateMobile.comment = "";
      let mobilenumber = "";
      this.primaryMobileNumber = {
        mode: "auto",
        defaultCountry: data.destcountry.isocode,
        autoFormat: false,
        dropdownOptions: {
          showFlags: true,
          disabled: true,
          showDialCodeInSelection: true,
        },
      };
      if (data.accno.no != "-") {
        try {
          const phoneNumber = parsePhoneNumber(
            data.accno.no,
            data.destcountry.isocode,
          );
          mobilenumber = phoneNumber.nationalNumber;
        } catch (error) {
          // If parsing fails, display the number as-is (removing country code for display)
          // This handles cases with duplicate country codes like +233+233558252791
          mobilenumber = data.accno.no.replace(data.destcountry.mobilecountrycode, "").trim();
        }
      }
      this.updateMobile.phoneNumber = mobilenumber;
      this.$bvModal.show("editMobileNetwork");
    },
    // Update Transaction momo munber
    updateMobileNetwork() {
      if (!this.mobileInputError) {
        this.isDisplayPhoneError = true;
        return;
      } else {
        this.isDisplayPhoneError = false;

        // Construct the full mobile number
        const fullMobileNumber = this.updateMobile.countryCode + this.updateMobile.phoneNumber;

        // Check for duplicate country code in the phone number
        // Pattern: country code appears twice consecutively (e.g., +233+233 or +233233)
        const countryCodePattern = this.updateMobile.countryCode.replace('+', '\\+');
        const duplicatePattern = new RegExp(`^${countryCodePattern}[+]?${countryCodePattern.replace('\\+', '')}`);

        if (duplicatePattern.test(fullMobileNumber)) {
          myFunction.showInfo(
            "Invalid phone number: Country code is duplicated. Please correct the phone number.",
            "error"
          );
          return;
        }

        // Additional validation: check if phone number already starts with country code
        if (this.updateMobile.phoneNumber.startsWith(this.updateMobile.countryCode) ||
            this.updateMobile.phoneNumber.startsWith(this.updateMobile.countryCode.replace('+', ''))) {
          myFunction.showInfo(
            "Invalid phone number: Phone number already contains the country code. Please enter only the national number.",
            "error"
          );
          return;
        }

        let params = {
          transactionid: this.updateMobile.id,
          momoproviderid: this.updateMobile.network.id,
          // mobile_number: fullMobileNumber,
          comment: this.updateMobile.comment,
        };
        this.$store
          .dispatch(UPDATE_TRANSACTION_MOMO_NUMBER, params)
          .then((response) => {
            if (response.status == 200) {
              myFunction.showInfo(response.data.message, "success");
              this.isDisplayPhoneError = false;
              this.$bvModal.hide("editMobileNetwork");
              this.getTransactionList();
            } else {
              if (response.data.detail) {
                myFunction.showInfo(response.data.detail, "error");
              } else {
                myFunction.showInfo(response.data.message, "error");
              }
            }
          });
      }
    },
    // redirect transaction Details
    transactionDetails(data) {
      const route = this.$router.resolve({
        name: "transaction-details",
        params: {
          ref_no: this.$CryptoJS.AES.encrypt(
            data.custRefno,
            "ref_no",
          ).toString(),
          transaction_id: this.$CryptoJS.AES.encrypt(
            data.id,
            "transaction_id",
          ).toString(),
        },
      });
      window.open(route.href, "_blank");
    },
    // View accounts
    viewAccounts(data) {
      let params = {};
      if (data.accno.type == "bank") {
        params.name = "Bank Account";
        params.value = data.accno.no;
      }
      if (data.accno.type == "mobile") {
        params.name = "MOMO Account";
        params.value = data.accno.no;
      }
      if (data.accno.type == "wallet") {
        params.name = "Wallet Account";
        params.value = data.accno.no;
      }
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },

    // get provider list
    async getProvider() {
      let params = ``;
      await this.$store.dispatch(GET_PROVIDER_LIST, params).then((response) => {
        if (response.status == 200) {
          this.payoutoption = response.data.details.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          this.provideroption = response.data.details.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
        }
      });
    },
    // Handle a genuine mid-session change to this user's HQ access (an admin toggled
    // their role or `can_process_hq_tx`). Reload the list and tell a non-SuperAdmin why
    // their visible transactions changed. Fired by the auth store's refreshPermissions.
    async onHqAccessChanged(event) {
      await this.getTransactionList();
      if (!this.isSuperAdminUser) {
        const active = event && event.detail && event.detail.active === true;
        this.$toast.info(
          active
            ? "Your access has been updated. You are now viewing HQ transactions only."
            : "Your access has been updated. You are now viewing standard (non-HQ) transactions only.",
          { position: "top-right" },
        );
      }
    },
    // for add comment on cancel and hold
    commentSubmit() {
      console.log(this.comment_transaction);
    },
    // for refund
    refund(item) {
      ((this.remitterCredit = {
        customer: item.sender.name,
        comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        amount: item.destamount?.destamount?.split(" ")[1],
        creditType: "",
        refundType: "Orignal Method",
      }),
        this.$bvModal.show("refund-Remitter-credit"));
    },
    transaction_comments(type) {
      this.comment_transaction.type = type;
      this.$bvModal.show("transaction_comment");
    },
    // for payout filters
    selectPayout() {
      setTimeout(() => {
        this.payoutSourceOption = [];
        this.advanceFilters.filter(
          (data) => data.field.id == "payout_source",
        )[0].payout.source = "";
      }, 100);
    },
    searchPayoutSource(event) {
      if (event.length > 0) {
        if (
          this.advanceFilters.filter(
            (data) => data.field.id == "payout_source",
          )[0].payout.type.value == "IBOBank"
        ) {
          this.payoutSourceOption = this.banks;
        }
        if (
          this.advanceFilters.filter(
            (data) => data.field.id == "payout_source",
          )[0].payout.type.value == "mobilemoney"
        ) {
          this.payoutSourceOption = this.mobileNetworks;
        }
      } else {
        this.payoutSourceOption = [];
      }
    },
    bulkSelectall() {
      setTimeout(() => {
        this.transactions.map((item) => {
          item.selected = this.selectAll;
        });
      }, 1);
    },
    showalertForbulkcapture() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to Change for all transactions ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                icon: "success",
                confirmButtonText: "Done",
              })
              .then(() => {
                this.bulkCapturestatus = "";
                this.$refs.transactionTable.refresh();
              });
          }
        });
    },
    statusBadges(item) {
      const transactionStatus = item ? item : "N/A";
      let status = { name: "N/A", class: "badge-grey-solid" };

      // New color scheme
      if (transactionStatus == "Success") {
        status = { name: "Success", class: "badge badge-success-solid" };
      } else if (transactionStatus == "Failed") {
        status = { name: "Failed", class: "badge badge-danger-solid" };
      } else if (transactionStatus == "Pending") {
        status = { name: "Pending", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Processing") {
        status = { name: "Processing", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Incomplete") {
        status = { name: "Incomplete", class: "badge badge-secondary" };
      } else if (transactionStatus == "Cancelled") {
        status = { name: "Cancelled", class: "badge badge-secondary" };
      } else if (transactionStatus == "Refunded") {
        status = { name: "Refunded", class: "badge badge-info-solid" };
      } else if (transactionStatus == "Ewallet Refunded") {
        status = { name: "Ewallet Refunded", class: "badge badge-info-solid" };
      } else if (transactionStatus == "In Progress") {
        status = { name: "In Progress", class: "badge badge-primary-solid" };
      } else if (transactionStatus == "Awaiting Funds") {
        status = { name: "Awaiting Funds", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Funds Received") {
        status = { name: "Funds Received", class: "badge badge-info-solid" };
      } else if (transactionStatus == "Sent for Payment") {
        status = {
          name: "Sent for Payment",
          class: "badge badge-primary-solid",
        };
      } else if (transactionStatus == "Recipient Paid") {
        status = { name: "Recipient Paid", class: "badge badge-success-solid" };
      } else if (transactionStatus == "In Review") {
        status = { name: "In Review", class: "badge badge-warning-solid-2" };
      } else {
        status = { name: transactionStatus, class: "badge badge-secondary" };
      }
      return status;
    },
    // transaction capture
    paymentCapture(data) {
      // this.showAlertTop=!this.showAlertTop;
      let params = {
        transaction_id: data.id,
      };
      this.$store
        .dispatch(TRANSACTION_PAYMENT_CAPTURE, params)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
          } else {
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
        });
    },
    /**
     * The action is only offered for a transaction the endpoint can actually act on:
     * still Incomplete, and paid through Checkout or Volume. The list already maps
     * paymentProvider to an object for exactly those two providers and leaves it an empty
     * string for everything else, so a wallet/manual/absent provider self-hides.
     */
    isPaymentVerifiable(item) {
      const status = (item?.status?.name || "").toString().toLowerCase();
      const provider = (item?.paymentProvider?.value || "").toString().toLowerCase();
      return (
        status === "incomplete" && (provider === "checkout" || provider === "volume")
      );
    },
    /**
     * Asks the provider what really happened and, when it confirms a single paid attempt,
     * moves the transaction to Processing. The response always carries `updated` and a
     * `message`, so a 200 does NOT mean the status changed - read `updated`.
     */
    verifyPaymentAndUpdateStatus(item) {
      const reference = (item?.custRefno || item?.reference_number || "")
        .toString()
        .trim();
      // custRefno falls back to the literal "-" when the row has no reference.
      if (!reference || reference === "-") {
        myFunction.showInfo(
          "This transaction has no reference number to verify",
          "error",
        );
        return;
      }

      this.paymentReconcile.reference = reference;
      this.paymentReconcile.result = null;

      this.$store
        .dispatch(RECONCILE_PAYMENT_STATUS, { reference_id: reference })
        .then((response) => {
          const payload = response && response.data ? response.data : null;

          if (!payload) {
            myFunction.showInfo(
              "No response from the payment verification service",
              "error",
            );
            return;
          }

          this.paymentReconcile.result = payload;
          this.$bvModal.show("paymentReconcileResult");

          if (payload.updated) {
            // The status moved to Processing, so the row is now stale.
            this.getTransactionList();
          }
        });
    },
    /** Bootstrap contextual class for the outcome banner. */
    reconcileOutcomeVariant(result) {
      if (!result) {
        return "secondary";
      }
      if (result.updated) {
        return "success";
      }
      if (result.verdict === "MULTIPLE_ACCEPTED_ATTEMPTS") {
        return "danger";
      }
      if (result.verdict === "CANNOT_DETERMINE") {
        return "warning";
      }
      return "secondary";
    },
    // transaction status check
    statusCheck(data) {
      let params = {
        transaction_id: data.id,
      };
      this.$store
        .dispatch(CHECK_TRANSACTION_STATUS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            // Map API response code to transaction status
            let transactionStatus = "Awaiting Callback"; // Default status

            if (response.data.code === "SUCCESS") {
              transactionStatus = "Recipient Paid";
            } else if (
              response.data.code === "FAILED" ||
              response.data.code === "Failed"
            ) {
              transactionStatus = "Failed";
            }
            // If code is neither SUCCESS nor FAILED, keep "Awaiting Callback"

            // Update the transaction status in the list
            this.transactions.filter((item) => item.id == data.id)[0].status =
              this.statusBadges(transactionStatus);
          } else {
            this.transactionProcessClearData();
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
        });
    },
    // transaction Process for Payout
    transactionProcessPayout(data) {
      // this.transactionProcess.transaction_id = data.id;
      // this.transactionProcess.status = data.status;
      // if(this.transactionProcess.status.name == "Sent for Payment"){
      //     if(data.payoutStatus){
      //         this.transactionProcess.providerid = data.payoutStatus;
      //         this.transactionProcessSubmit();
      //     } else {
      //         this.transactionProcessClearData();
      //         myFunction.showInfo('Payout must be set to send for payment', "error");
      //     }
      // } else {
      //     this.$bvModal.show('transactionProcess');
      // }
      if (data.payoutProvider) {
        // Check if this is EUR currency with specific payment method, Awaiting Funds status, and "Funds received" option
        const isEURSpecialCase =
          data.sourceCurrencyCode === 'EUR' &&
          data.paymentMethodId === this.EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID &&
          data.status?.name === this.EUR_FUNDS_RECEIVED_STATUS &&
          data.payoutProvider.name &&
          data.payoutProvider.name.toLowerCase().includes('funds received');

        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary btn-lg my-3",
            cancelButton: "btn btn-outline-secondary btn-lg",
          },
          buttonsStyling: false,
        });

        // Show custom sweetalert for EUR special case with "Funds received"
        if (isEURSpecialCase) {
          swalWithBootstrapButtons.fire({
            title: "Funds Received",
            text: "Are you sure that the funds have been received?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              // Call transaction status update API
              let params = {
                transaction_id: data.id,
                transaction_status: "Funds Received"
              };
              this.$store
                .dispatch(UPDATE_TRANSACTION_STATUS, params)
                .then((response) => {
                  if (response.status == 200) {
                    myFunction.showInfo(response.data.message, "success");
                    // Reset the dropdown value before refreshing
                    data.payoutProvider = " ";
                    this.getTransactionList();
                  } else {
                    myFunction.showInfo(response.data.message, "error");
                  }
                  this.transactionProcessClearData();
                });
            } else {
              // Reset the dropdown value on cancel
              data.payoutProvider = " ";
              this.transactionProcessClearData();
            }
          });
        } else {
          // Standard confirmation flow for all other cases
          swalWithBootstrapButtons
            .fire({
              title: "Are you sure?",
              text: "Confirm Transaction",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.transactionProcess.transaction_id = data.id;
                this.transactionProcess.status = "Sent for Payment";
                this.transactionProcess.providerid =
                  data.payoutProvider.providerid;
                this.transactionProcessSubmit();
              } else {
                this.transactionProcessClearData();
              }
            });
        }
      } else {
        this.transactionProcessClearData();
        myFunction.showInfo("Payout must be set to send for payment", "error");
      }
    },
    // transaction Process for review and cancel
    transactionProcessReviewAndCancel(data, type) {
      this.transactionProcess.transaction_id = data.id;
      this.transactionProcess.status = type;
      if (type == "Cancelled") {
        this.transactionReasons = [
          "Duplicate",
          "Compliance",
          "Payment Method",
          "Payout Method",
          "Incorrect Sender",
          "Incorrect Amount",
        ];
      } else {
        this.transactionReasons = ["CE Hold", "Compliance Hold"];
      }
      if (type == "Processing") {
        this.transactionProcessSubmit();
      } else {
        this.$bvModal.show("transactionProcess");
      }
    },
    transactionProcessClearData() {
      this.transactions = JSON.parse(JSON.stringify(this.transactionsCopy));
      this.transactionProcess.transaction_id = "";
      this.transactionProcess.status = "";
      this.transactionProcess.reason = "";
      this.transactionProcess.refundmethod = "";
      this.transactionProcess.comment = "";
      this.transactionProcess.providerid = "";
      this.$bvModal.hide("transactionProcess");
    },
    // transaction Process submit api
    transactionProcessSubmit() {
      let params = {
        transaction_id: this.transactionProcess.transaction_id,
        transaction_status: this.transactionProcess.status,
      };
      if (
        this.transactionProcess.status == "In Review" ||
        this.transactionProcess.status == "Cancelled"
      ) {
        params.reason = this.transactionProcess.reason;
        params.comment = this.transactionProcess.comment;
      }
      if (this.transactionProcess.status == "Cancelled") {
        params.refund_method = this.transactionProcess.refundmethod;
      }
      if (this.transactionProcess.status == "Sent for Payment") {
        params.provider = this.transactionProcess.providerid;
      }
      this.$store.dispatch(PROCESS_TRANSACTIONS, params).then((response) => {
        if (response.status == 200) {
          const code = response.data.code;
          if (code === "FAILED") {
            this.transactionProcessClearData();
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
            this.$bvModal.hide("transactionProcess");
          }
        } else {
          const code = response.data.code;
          if (code === 'E1005-042') {
            this.avsWarningPendingParams = params;
            this.avsWarningReason = response.data.message || 'AVS check failed';
            this.$bvModal.show('avsWarningModal');
            return;
          }
          this.transactionProcessClearData();
          // E1005-044: the dispatch attempt-count guard just raised a pending DISPATCH_APPROVAL
          // (ENG-2069) — refresh in place so the row shows the pending pill and hides Retry without
          // a manual reload, the same as E1005-036/037.
          if(code == 'E1005-036' || code == 'E1005-037' || code == 'E1005-044') {
            this.getTransactionList();
          }
          if (response.data.message) {
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        }
      });
    },
    confirmAvsOverride() {
      this.$bvModal.hide('avsWarningModal');
      const params = { ...this.avsWarningPendingParams, skipAvsCheck: true };
      this.avsWarningPendingParams = null;
      this.$store.dispatch(PROCESS_TRANSACTIONS, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
          this.getTransactionList();
        } else {
          this.transactionProcessClearData();
          if (response.data.message) {
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        }
      });
    },
    cancelAvsOverride() {
      this.avsWarningPendingParams = null;
      this.avsWarningReason = '';
      this.$bvModal.hide('avsWarningModal');
      this.transactionProcessClearData();
    },
    transactionNotificationSubmit() {
      console.log("transactionNotificationSubmit", this.notification);
    },
    sendNotification(data) {
      console.log(data);
      this.$bvModal.show("transactionNotification");
    },
    trans_status_update(data) {
      // console.log(data);
      this.getTransactionStatus();
      this.transactionStatusUpdate.transaction_id = data.id;
      this.transactionStatusUpdate.status = "";
      this.transactionStatusUpdate.comment = "";
      this.$bvModal.show("transactionStatusUpdate");
    },
    // pdfLink is the uploaded proof-of-payment reported by the list API. It is
    // set whenever a file exists, independent of transaction status — reviewers
    // need to open the proof precisely while the funding is still pending.
    hasReceipt(item) {
      return !!item.pdfLink;
    },
    // Path is relative: axios.defaults.baseURL already carries the API base.
    async fetchReceiptPdf(transactionId) {
      const response = await this.$http.get(
        `transaction/funding-proof/${transactionId}`,
        { responseType: "blob" },
      );
      return new Blob([response.data], { type: "application/pdf" });
    },
    async viewTransactionPDF(data) {
      try {
        if (!data.id) {
          this.$toast.error("Transaction ID not found");
          return;
        }

        const blob = await this.fetchReceiptPdf(data.id);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `transaction_receipt_${data.custRefno || data.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success("Receipt downloaded successfully");
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.$toast.error("Failed to download receipt");
      }
    },
    async viewReceiptInTab(data) {
      try {
        if (!data.id) {
          this.$toast.error("Transaction ID not found");
          return;
        }

        const blob = await this.fetchReceiptPdf(data.id);
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");

        // Clean up the URL after a delay to allow the tab to load
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);

        this.$toast.success("Receipt opened in new tab");
      } catch (error) {
        console.error("Error opening PDF:", error);
        this.$toast.error("Failed to open receipt");
      }
    },
    ibd_status_update(data) {
      console.log(data);
      this.$bvModal.show("IBDStatusUpdate");
    },
    trans_payout_status_update(data) {
      // console.log(data);
      this.payoutStatusUpdate.transaction_id = data.id;
      this.payoutStatusUpdate.provider = "";
      this.payoutStatusUpdate.comment = "";
      this.$bvModal.show("payoutStatusUpdate");
    },
    manualConfirmSuccess(data) {
      this.manualConfirm.transaction_id = data.id;
      this.manualConfirm.title = "Transaction Success (Manual Confirm)";
      this.manualConfirm.reference_number = data.custRefno;
      this.manualConfirm.status = "Recipient Paid";
      this.manualConfirm.comment = "";
      this.$bvModal.show("manualConfirmModal");
    },
    manualConfirmFailed(data) {
      this.manualConfirm.transaction_id = data.id;
      this.manualConfirm.title = "Transaction Failed (Manual Confirm)";
      this.manualConfirm.reference_number = data.custRefno;
      this.manualConfirm.status = "Failed";
      this.manualConfirm.comment = "";
      this.$bvModal.show("manualConfirmModal");
    },
    manualConfirmSubmit() {
      let params = {
        transaction_id: this.manualConfirm.transaction_id,
        transaction_status: this.manualConfirm.status,
        comment: this.manualConfirm.comment,
      };
      const action = this.manualConfirm.status === "Recipient Paid"
        ? MANUAL_SUCCESS_TRANSACTION
        : MANUAL_FAIL_TRANSACTION;
      this.$store.dispatch(action, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
          this.$bvModal.hide("manualConfirmModal");
          this.getTransactionList();
        } else {
          if (response.data.message) {
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        }
      });
    },
    statusUpdateSubmit(type) {
      console.log("type", type);
      if (type == "transaction") {
        // console.log('transactionStatusUpdate',this.transactionStatusUpdate)
        let params = {
          transaction_id: this.transactionStatusUpdate.transaction_id,
          transaction_status: this.transactionStatusUpdate.status.status,
          comment: this.transactionStatusUpdate.comment,
        };
        this.$store
          .dispatch(UPDATE_TRANSACTION_STATUS, params)
          .then((response) => {
            if (response.status == 200) {
              myFunction.showInfo(response.data.message, "success");
              this.getTransactionList();
              this.$bvModal.hide("transactionStatusUpdate");
            } else {
              myFunction.showInfo(response.data.detail || response.data.message, "error");
            }
          });
      }
      if (type == "IBD") {
        console.log("IBDStatusUpdate", this.IBDStatusUpdate);
      }
      if (type == "payout_status") {
        // console.log('payout_status',this.transactionPayout)
        let params = {
          transaction_id: this.payoutStatusUpdate.transaction_id,
          provider_id: this.payoutStatusUpdate.provider.providerid,
          comment: this.payoutStatusUpdate.comment,
        };
        this.$store.dispatch(UPDATE_PAYOUT_STATUS, params).then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
            this.$bvModal.hide("payoutStatusUpdate");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        });
      }
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters.length == 0) {
        this.advanceFilters = [
          {
            field: { id: "firstname", name: "Sender First Name", $isDisabled: true },
            search: "",
            country: [],
            transactionStatus: [],
            history: {
              sender: "",
              receiver: "",
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // to append another Filter
    appendFilter() {
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          country: [],
          transactionStatus: [],
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
          payout: {
            type: "",
            source: "",
          },
        });
        if (
          this.filterField.filter((data) => data.$isDisabled == false)[0].id !=
          "amount"
        ) {
          this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0].$isDisabled = true;
        }
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
        if (item.field.id != "amount") {
          item.amount.type = "";
          item.amount.value = "";
        }
      });
      this.amountFieldUpdate();
    },
    // to remove filters
    removeFilter(index) {
      if (this.advanceFilters[index].field.id == "amount") {
        this.amountOptions.filter(
          (data) => data.id == this.advanceFilters[index].amount.type.id,
        )[0].$isDisabled = false;
      }
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },
    // remove transaction sattus filters
    removeStatus(status, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let statuses = [];
      let statusesobj = [];
      temp.map((item) => {
        if (item != status) {
          statuses.push(item);
          statusesobj.push(
            this.transactionStatus.filter((data) => data === item)[0],
          );
        }
      });
      if (statuses.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = statuses;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].transactionStatus = statusesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove date filters
    removePayoutSource(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].payout[indexValue] = "";
      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.type == "" && temp.source == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "payout_source",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove transaction_history filters
    removetransaction_history(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].history[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.sender == "" && temp.receiver == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "transaction_history",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      if (this.$route.query.filter) {
        if (this.$route.query.sender && this.$route.query.receiver) {
          if (indexValue == "receiver") {
            this.$router.replace({
              query: { filter: "true", sender: this.$route.query.sender },
            });
          }
          if (indexValue == "sender") {
            this.$router.replace({
              query: { filter: "true", receiver: this.$route.query.receiver },
            });
          }
        } else {
          this.$router.replace({ query: {} });
          this.displayFilters = [];
        }
      } else {
        this.$cookies.set("transaction-list-filter", this.displayFilters);
      }
    },

    // amount filter fields update
    amountFieldUpdate() {
      this.amountOptions.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (item.amount.type) {
          this.amountOptions.filter(
            (data) => data.id == item.amount.type.id,
          )[0].$isDisabled = true;
        }
      });
    },

    // apply filters
    applyTestfilter() {
      if (this.$route.query.filter) {
        this.$router.replace({ query: {} });
      }
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (
          item.field.id == "firstname" ||
          item.field.id == "middlename" ||
          item.field.id == "lastname" ||
          item.field.id == "receiverfirstname" ||
          item.field.id == "receivermiddlename" ||
          item.field.id == "receiverlastname" ||
          item.field.id == "senderemail" ||
          item.field.id == "receiveremail" ||
          item.field.id == "senderphone" ||
          item.field.id == "receiverphone" ||
          item.field.id == "transactiontype" ||
          item.field.id == "payment_res_id" ||
          item.field.id == "payout_res_id" ||
          item.field.id == "transaction_ref" ||
          item.field.id == "ip_address" ||
          item.field.id == "bank_name"
        ) {
          data.filter_value = item.search;
        }
        // Fix for mobile_network: store array of selected provider IDs for API, and objects for display
        if (item.field.id == "mobile_network") {
          data.filter_value = Array.isArray(item.mobile_network)
            ? item.mobile_network.map((opt) => opt.id || opt.value || opt)
            : [];
          data._mobile_network_objs = Array.isArray(item.mobile_network)
            ? item.mobile_network
            : [];
        }
        if (item.field.id == "country" || item.field.id == "sourcecountry") {
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        if (item.field.id == "transaction_status") {
          let statuses = [];
          item.transactionStatus.map((status) => {
            statuses.push(status);
          });
          data.filter_value = statuses;
        }
        if (item.field.id == "remitterstatus") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "payment_id") {
          data.filter_value = item.search.value;
          data.filter_label = item.search.name;
        }
        if (item.field.id == "cko_capture") {
          data.filter_value = item.search.name;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        if (item.field.id == "amount") {
          if (item.amount.type && item.amount.value) {
            data.filter_value = item.amount.type.id + ": " + item.amount.value;
          }
        }
        if (item.field.id == "transaction_history") {
          data.filter_value = {
            sender: item.history.sender ? item.history.sender : "",
            receiver: item.history.receiver ? item.history.receiver : "",
          };
        }

        if (item.field.id == "payout_source") {
          data.filter_value = {
            type: item.payout.type.value ? item.payout.type.value : "",
            source: item.payout.source.value ? item.payout.source.value : "",
          };
        }

        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("transaction-list-filter", params);
      this.displayFilters = this.$cookies.get("transaction-list-filter");
    },
    // clear all filters
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "firstname", name: "Sender First Name", $isDisabled: true },
          search: "",
          country: [],
          transactionStatus: [],
          history: {
            sender: "",
            receiver: "",
          },
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      if (!this.$route.query.filter) {
        this.$cookies.set("transaction-list-filter", this.displayFilters);
      }
      this.getTransactionList();
    },
    customerDetailModel(item) {
      let params = {
        customer_id: item,
      };
      this.customerDetail = params;
      if (this.customerDetail.customer_id) {
        // Use $nextTick to ensure the prop is updated before modal opens
        this.$nextTick(() => {
          this.$bvModal.show("customer-details");
        });
      } else {
        myFunction.showInfo("Customer Details Not found", "error");
        this.customerDetail = null;
      }
    },
    getSelectedDateRange(e) {
      let startDate = moment(e[0]).format("D-MM-YYYY");
      let endDate = moment(e[1]).format("D-MM-YYYY");

      let tempArr = [];
      this.transactions.map((data) => {
        let formatResponseData = moment(data.datetime.date).format("D-MM-YYYY");

        var d1 = startDate.split("-");
        var d2 = endDate.split("-");
        var c = formatResponseData.split("-");

        var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]); // -1 because months are from 0 to 11
        var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
        var check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

        if (check >= from && check <= to) {
          tempArr.push(data);
        }
      });
      this.transactions = tempArr;
      this.totalRows = this.transactions.length;
    },
    convertDate(data) {
      return moment(data).utc().format("DD-MM-YYYY HH:mm:ss");
    },
    convertToString(data) {
      return JSON.stringify(data);
    },
    async showTransactionDetail(data) {
      // console.log(data);
      this.$refs.loader.show();
      try {
        let paramData = {
          customer_ref: data.cust_ref, //'PA-64b501e0090921689584096-1'
        };
        const response = await this.$http.get(
          this.$apiV2transaction + "payment/transactions-details/",
          {
            params: paramData,
          },
        );
        if (response.data.code == "0130-000") {
          if (response.data.data.length > 0) {
            const transactionDetail = response.data;

            this.transactionDetail.accName = data.accno.acc;
            this.transactionDetail.accNumber = data.accno.no;
            this.transactionDetail.sendername =
              transactionDetail.senderFirstName +
              " " +
              transactionDetail.senderLastName;
            this.transactionDetail.beneficiaryname =
              transactionDetail.beneficiaryFirstName +
              " " +
              transactionDetail.beneficiaryLastName;
            this.transactionDetail.destamount =
              transactionDetail.receivingCurrency +
              " " +
              parseFloat(transactionDetail.destinationAmount).toFixed(2);
            this.transactionDetail.refno = data.cust_ref;
            this.transactionDetail.srcamount = data.srcamount;
            this.transactionDetail.transStatus = data.status.name;

            this.transactionDetail.details = response.data.data;
            //this.errorMsg = '';
            this.detailsstatus = false;
            this.$bvModal.show("show-details");
            this.$refs.loader.hide();
          } else {
            // console.log('No record found');
            this.detailsstatus = true;
            this.errorMsg = "No Details Found";
            this.$bvModal.show("show-details");
            this.$refs.loader.hide();
          }
        }
      } catch (error) {
        console.log(error);
        if (error.response.data.code == "E0130-001") {
          this.detailsstatus = true;
          this.errorMsg =
            "There are some validation error occured. Please refer merchant backend website";
          this.$bvModal.show("show-details");
          this.$refs.loader.hide();
        }
        this.$refs.loader.hide();
      }
    },

    //copy
    copyValue(keyvalue) {
      var copyVal = "";
      if (typeof keyvalue == "object") {
        copyVal = JSON.stringify(keyvalue);
      } else {
        copyVal = keyvalue;
      }
      navigator.clipboard.writeText(copyVal);
      shared.toastrSuccess("Successfully copied");
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    // showEdit(data){
    //     console.log(data);
    //     this.$router.push({ path: '/customer/edit' })
    // }
    async getTransactionList() {
      // Ensure countryList is loaded before proceeding
      if (!this.countryList || this.countryList.length === 0) {
        return;
      }
      // Refresh the payout-provider list on every list (re)load so the Payout
      // dropdown reflects the user's current HQ-transaction eligibility without a
      // full page refresh. The backend resolves eligibility live per request, so a
      // change to `can_process_hq_tx` takes effect on the next list reload.
      // Fire-and-forget so it never delays the transaction fetch below.
      this.getProvider();
      let page = "";
      let size = "";
      let sortby = "";
      let sort = "";
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        size = this.perPage;
      } else {
        size = 10;
      }
      if (this.sortBy == "" || this.sortBy == "datetime") {
        sortby = "createdAt";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "desc"; //"DESC";
      } else {
        sort = "asc"; //"ASC";
      }

      this.currentPageJump = page;
      const tempitems = [];
      let tempparam = `?sort=${sort}&sortby=${sortby}&limit=${size}&page=${page}`; //
      // ENG-2348 — which team view this is. The server re-checks it against the
      // caller's view permission and 403s a team they don't hold, so this selects
      // among the views the user already has rather than granting access.
      if (this.teamScope) {
        tempparam = tempparam + `&team=${this.teamScope}`;
      }
      if (this.searchText) {
        tempparam = tempparam + `&search=${this.searchText.trimStart()}`;
      }

      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          if (item.filter_field == "date") {
            tempparam = tempparam + `&date_from=${item.filter_value.from}`;
            tempparam = tempparam + `&date_to=${item.filter_value.to}`;
          }
          // else if (item.filter_field == "payout_source") {
          //   tempparam = tempparam + `&payout_type=${item.filter_value.type}`;
          //   tempparam =
          //     tempparam + `&payout_source=${item.filter_value.source}`;
          // }
          else if (item.filter_field == "transaction_history") {
            tempparam = tempparam + `&sender=${item.filter_value.sender}`;
            // tempparam = tempparam + `&receiver=${item.filter_value.receiver}`;
          } else if (item.filter_field == "amount") {
            let value = item.filter_value.split(":");
            tempparam = tempparam + `&amount=${value[1].replace(" ", "")}`;
            tempparam = tempparam + `&amount_type=${value[0]}`;
            // tempparam =
            //   tempparam +
            //   `&amount_${value[0]
            //     .replace(" ", "_")
            //     .toLowerCase()}=${value[1].replace(" ", "")}`;
          } else if (item.filter_field == "transaction_status") {
            item.filter_value.map((status) => {
              tempparam = tempparam + `&${item.filter_field}=${status}`;
            });
          } else if (
            item.filter_field == "transactiontype" &&
            item.filter_value == "HQ Transactions"
          ) {
            // "HQ Transactions" is not a payout type — it maps to the SuperAdmin-only
            // is_hq_tx flag on the API (honoured for SuperAdmins, ignored for others).
            tempparam = tempparam + `&is_hq_tx=1`;
          } else {
            tempparam =
              tempparam + `&${item.filter_field}=${item.filter_value}`;
          }
        });
      }
      await this.$store
        .dispatch(GET_TRANSACTION_LIST, tempparam)
        .then((response) => {
          // JSON responses are automatically parsed.
          if (response.status == 200) {
            response.data.details.map((item) => {
              let accType = "";
              let accname = "";
              let accNumber = "";

              // Check for PW wallet transactions (reference starts with "PW" and source amount != dest amount)
              const isPWWallet =
                item.reference_number &&
                item.reference_number.startsWith("PW") &&
                item.sourceAmount &&
                item.destAmount;
              // &&  parseFloat(item.sourceAmount) !== parseFloat(item.destAmount);
              if (isPWWallet) {
                accType = "wallet";
                // Create intuitive wallet name showing currency swap
                const sourceCountryData = this.countryList.filter(
                  (data) => data.countryname === item.senderCountry,
                )[0];
                const destCountryData = this.countryList.filter(
                  (data) => data.currencycode === item.destCurrency,
                )[0];

                const sourceCurrency = sourceCountryData?.currency || "USD";
                const destCurrency =
                  destCountryData?.currency || item.destCurrency || "GHS";
                const walletSwapName = `${sourceCurrency} → ${destCurrency} Wallet`;
                accname = item.walletName ? item.walletName : walletSwapName;
                accNumber = item.accountNumber ? item.accountNumber : "-";
              } else if (item.payoutType == "Mobile Money") {
                accType = "mobile";
                accname = item.mobileNetwork ? item.mobileNetwork : "-";
                accNumber = item.mobileNumber ? item.mobileNumber : "-";
              } else if (item.payoutType == "Payangel Wallet") {
                accType = "wallet";
                accname = item.walletName ? item.walletName : "N/A";
                accNumber = item.accountNumber ? item.accountNumber : "-";
              } else {
                accType = "bank";
                accname = item.accountName ? item.accountName : "N/A";
                accNumber = item.accountNumber ? item.accountNumber : "-";
              }

              const transactionStatus = item.transactionStatus
                ? item.transactionStatus
                : "N/A";

              let platform = "";
              if (item.platform) {
                if (item.platform.toLowerCase() == "ios") {
                  platform = "fa fa-apple font-14 mr-1";
                } else if (item.platform.toLowerCase() == "android") {
                  platform = "fa fa-android text-success font-14 mr-1";
                } else if (item.platform.toLowerCase() == "admin") {
                  platform = "fa fa-user font-14 mr-1";
                } else if (item.platform.toLowerCase() == "web") {
                  platform = "fa fa-globe text-info font-14 mr-1";
                }
              }

              let paymentProvider = "";
              if (item.paymentProvider) {
                if (item.paymentProvider.toLowerCase() == "volume") {
                  paymentProvider = {
                    value: item.paymentProvider,
                    class: "text-purple",
                  };
                }
                if (item.paymentProvider.toLowerCase() == "checkout") {
                  paymentProvider = {
                    value: item.paymentProvider,
                    class: "text-blue",
                  };
                }
              }

              const senderfname = item.senderFirstName
                ? item.senderFirstName
                : "-";
              const senderlname = item.senderLastName
                ? item.senderLastName
                : "-";
              const beneficiaryfname = item.receiverFirstName
                ? item.receiverFirstName
                : "-";
              const beneficiarylname = item.receiverLastName
                ? item.receiverLastName
                : "-";

              // Determine payoutProvider logic
              let payoutProviderObj = " ";

              // For PW transactions with status ID 7, automatically set to Wallet
              if (item.reference_number &&
                  item.reference_number.startsWith('PW') &&
                  item.transactionStatusId === 7 &&
                  Array.isArray(this.payoutoption)) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (option) => option.name && option.name.toLowerCase().includes('wallet')
                  ) || " ";
              } else if (
                (transactionStatus === "Recipient Paid" ||
                 transactionStatus === "Sent for Payment" ||
                 transactionStatus === "Awaiting Callback" ||
                 transactionStatus === "Failed") &&
                item.latestPayoutProviderId &&
                Array.isArray(this.payoutoption)
              ) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (provider) =>
                      provider.providerid === item.latestPayoutProviderId ||
                      provider.id === item.latestPayoutProviderId, // fallback for different id keys
                  ) || " ";
              } else if (
                item.payoutProvider &&
                Array.isArray(this.payoutoption)
              ) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (data) => data.name === item.payoutProvider,
                  ) || " ";
              }

              let transactionLists = {
                id: item.id,
                srccountry: {
                  flagClass:
                    "flag-icon flag-icon-" +
                    this.countryList.filter(
                      (data) => data.countryname === item.senderCountry,
                    )[0]?.isocode +
                    " fi-lg fi-round",
                },
                datetime: item.transaction_date,
                sender: { name: senderfname + " " + senderlname },
                benificiary: {
                  name: beneficiaryfname + " " + beneficiarylname,
                },
                // Carry the split receiver names (already returned by the list API) onto the
                // row object so the reroute NAME_CORRECTION form can prepopulate them.
                receiverFirstName: item.receiverFirstName || "",
                receiverMiddleName: item.receiverMiddleName || "",
                receiverLastName: item.receiverLastName || "",
                accno: { type: accType, acc: accname, no: accNumber },
                destamount: item.destAmount
                  ? parseFloat(item.destAmount).toFixed(2)
                  : "N/A",
                custRefno: item.reference_number ? item.reference_number : "-",
                payout_res_id: item.payoutResID ? item.payoutResID : "-",
                payment_res_id: item.paymentResID ? item.paymentResID : "-",
                isCaptured: item.isCaptured,
                status: this.statusBadges(transactionStatus),
                transactionStatusId: item.transactionStatusId,
                payoutProvider: payoutProviderObj,
                paymentProvider: paymentProvider,
                customer_id: item.customerid,
                receiver_id: item.beneficaryId,
                transaction_id: item.transaction_id ? item.transaction_id : "-",
                uuid: item.id ? item.id : "-",
                sourceamount: item.sourceAmount
                  ? parseFloat(item.sourceAmount).toFixed(2)
                  : "N/A",
                platform: platform,
                country: this.countryList.filter(
                  (data) => data.countryname === item.senderCountry,
                )[0],
                destcountry: this.countryList.filter(
                  (data) => data.currencycode === item.destCurrency,
                )[0],
                sourceCurrencyCode:
                  item.sourceCurrency ||
                  this.countryList.filter(
                    (data) => data.countryname === item.senderCountry,
                  )[0]?.currencycode,
                destCurrencyCode: item.destCurrency,
                customerGroup: item.customerGroup ? item.customerGroup : "",
                noOfReceiver: item.noOfReceiver ? item.noOfReceiver : "-",
                senderCard: item.senderCard ? item.senderCard : "-",
                // ENG-2174: left undefined when the backend predates ENG-2172, so the
                // popover hides the breakdown rather than claiming a misleading zero.
                // Not defaulted to "-" like senderCard above, because a real 0 is
                // meaningful here: "Active: 0" is exactly what an agent needs to see.
                senderActiveCards: item.senderActiveCards,
                senderDeletedCards: item.senderDeletedCards,
                senderBlockedCards: item.senderBlockedCards,
                senderDTV: item.senderDTV ? item.senderDTV : "-",
                senderLTV: item.senderLTV ? item.senderLTV : "-",
                senderMTV: item.senderMTV ? item.senderMTV : "-",
                merchantReceiver: item.merchantReceiver
                  ? item.merchantReceiver
                  : isPWWallet
                    ? "PayWallet Business"
                    : null,
                // Numeric primary key of the business wallet transaction, used
                // to fetch the stored receipt. Never fall back to
                // reference_number: it is a string like "PW99786521" and the
                // receipt endpoint looks the id up as an integer PK, so the
                // fallback both revealed the receipt actions and guaranteed
                // they would fail.
                businessWalletTransactionId:
                  item.businessWalletTransactionId || null,
                // Filename of the stored receipt, empty when none was uploaded.
                pdfLink: item.pdfLink || "",
                paymentMethodId: item.paymentMethodId,
                latestPayoutProviderId: item.latestPayoutProviderId || null,
                pendingReroutes: item.pendingReroutes || [],
                selected: false,
                paymentMethod: item.paymentMethod ? item.paymentMethod : "-",
                additionalInfo: item.additionalFields ? item.additionalFields?.need_payout_data_correction : false,
              };
              tempitems.push(transactionLists);
            });
            this.totalRows = response.data.query.total;
          } else {
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
          this.transactions = tempitems;
          this.transactionsCopy = JSON.parse(JSON.stringify(tempitems));
          this.fetchRowRisk(tempitems);
        });
    },

    // Batch-fetch remitter + receiver linked-risk for the visible transactions and show
    // both as inline badges under the sender/receiver names (chunked to the 50 batch cap).
    async fetchRowRisk(rows) {
      this.senderRisk = {};
      this.receiverRisk = {};
      const chunk = (arr, n) => {
        const out = [];
        for (let i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
        return out;
      };
      const senderIds = [...new Set((rows || []).map((r) => r.customer_id).filter(Boolean))];
      const receiverIds = [...new Set((rows || []).map((r) => r.receiver_id).filter(Boolean))];
      if (!senderIds.length && !receiverIds.length) {
        this.riskLoading = false;
        return;
      }
      // Show a skeleton under sender/receiver names until the risk batch resolves.
      this.riskLoading = true;
      try {
        await Promise.all([
          ...chunk(senderIds, 50).map((ids) =>
            this.$store.dispatch(GET_LINKED_RISK_BATCH, ids).then((res) => {
              if (res && res.status == 200 && res.data.details) {
                this.senderRisk = { ...this.senderRisk, ...res.data.details };
              }
            }),
          ),
          ...chunk(receiverIds, 50).map((ids) =>
            this.$store.dispatch(GET_RECEIVER_RISK_BATCH, ids).then((res) => {
              if (res && res.status == 200 && res.data.details) {
                this.receiverRisk = { ...this.receiverRisk, ...res.data.details };
              }
            }),
          ),
        ]);
      } finally {
        this.riskLoading = false;
      }
    },
    senderRiskFor(customerId) {
      const r = customerId && this.senderRisk[customerId];
      return r && r.level ? r.level : null;
    },
    receiverRiskFor(receiverId) {
      const r = receiverId && this.receiverRisk[receiverId];
      return r && r.level ? r.level : null;
    },
    // A receiver is a beneficiary, not a customer — open the Edit Receiver page (details
    // sourced from the beneficiary table). basicInfo needs BOTH beneficiary_id and the
    // sender's customer_id, so pass both. Uses in-app navigation (params kept in memory)
    // to avoid the base64-in-URL round-trip breaking the encrypted ids on a fresh load.
    openReceiverDetails(item) {
      if (!item || !item.receiver_id) return;
      this.$router.push({
        name: "beneficiary-edit",
        params: {
          beneficiary_id: this.$CryptoJS.AES.encrypt(item.receiver_id, "beneficiary_id").toString(),
          customer_id: this.$CryptoJS.AES.encrypt(item.customer_id || "", "customer_id").toString(),
        },
      });
    },

    refreshTransactionTable() {
      this.$refs.transactionTable.refresh();
    },

    clearSearch() {
      this.searchText = "";
      this.$refs.transactionTable.refresh();
    },


    setprovider(data) {
      // console.log(data);
      this.tradenameid = data.id;
      this.refreshTransactionTable();
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
    cookieFilters() {
      if (this.$route.query.filter) {
        this.advanceFilters = [
          {
            field: {
              id: "transaction_history",
              name: this.filterField.filter(
                (data) => data.id == "transaction_history",
              )[0].name,
              $isDisabled: true,
            },
            search: "",
            country: [],
            transactionStatus: [],
            history: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
        this.displayFilters = [
          {
            filter_field: "transaction_history",
            field_name: "Transaction History",
            filter_value: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
          },
        ];
      } else {
        this.displayFilters =
          this.$cookies.get("transaction-list-filter") != null
            ? this.$cookies.get("transaction-list-filter")
            : [];
        let filters = [];
        if (this.displayFilters.length == 0) {
          this.displayFilters = [
            {
              filter_field: "transaction_status",
              field_name: "Transaction Status",
              filter_value: [
                "Processing",
                "Awaiting Funds",
                "Failed",
                "In Review",
              ],
            },
          ];
        }
        if (this.displayFilters && this.displayFilters.length > 0) {
          this.displayFilters.map((item) => {
            this.filterField.filter(
              (data) => data.id == item.filter_field,
            )[0].$isDisabled = true;
            if (
              item.filter_field == "firstname" ||
              item.filter_field == "middlename" ||
              item.filter_field == "lastname" ||
              item.filter_field == "receiverfirstname" ||
              item.filter_field == "receivermiddlename" ||
              item.filter_field == "receiverlastname" ||
              item.filter_field == "senderemail" ||
              item.filter_field == "receiveremail" ||
              item.filter_field == "senderphone" ||
              item.filter_field == "receiverphone" ||
              item.filter_field == "transactiontype" ||
              item.filter_field == "payment_res_id" ||
              item.filter_field == "payout_res_id" ||
              item.filter_field == "id" ||
              item.filter_field == "ip_address" ||
              item.filter_field == "mobile_network" ||
              item.filter_field == "bank_name"
            ) {
              console.log(item.filter_value);
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: item.filter_value,
                country: [],
                transactionStatus: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "remitterstatus") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: this.remiterOption.filter(
                  (data) => data.name == item.filter_value,
                )[0],
                country: [],
                transactionStatus: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "transaction_status") {
              let statuses = [];
              item.filter_value.map((status) => {
                statuses.push(
                  this.transactionStatus.filter((data) => data === status)[0],
                );
              });
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                transactionStatus: statuses,
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }

            if (
              item.filter_field == "country" ||
              item.filter_field == "sourcecountry"
            ) {
              let countries = [];
              item.filter_value.map((country) => {
                countries.push(
                  this.countryList.filter(
                    (data) => data.countryid === country,
                  )[0],
                );
              });
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: countries,
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "date") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: item.filter_value.from,
                  to: item.filter_value.to,
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "transaction_history") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: item.filter_value.sender,
                  receiver: item.filter_value.receiver,
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "amount") {
              this.amountOptions.filter(
                (data) => data.name == item.filter_value.split(":")[0],
              )[0].$isDisabled = true;
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: this.amountOptions.filter(
                    (data) => data.name == item.filter_value.split(":")[0],
                  )[0],
                  value: item.filter_value.split(":")[1],
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "payout_source") {
              if (item.filter_value.type == "IBOBank") {
                this.payoutSourceOption = this.banks;
              }
              if (item.filter_value.type == "mobilemoney") {
                this.payoutSourceOption = this.mobileNetworks;
              }
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: this.filterpayouttype.filter(
                    (data) => data.value == item.filter_value.type,
                  )[0],
                  source: this.payoutSourceOption.filter(
                    (data) => data.value == item.filter_value.source,
                  )[0],
                },
              });
            }
          });
          this.advanceFilters = filters;
        }
      }
    },
    // get transaction status list
    getTransactionStatus() {
      this.$store.dispatch(GET_TRANSACTION_STATUS).then((response) => {
        if (response.data.code == "1005-000") {
          // Filter out "Funds Received" from the status update options
          this.UpdateStatusoption = response.data.details.filter(
            status => status.status !== "Funds Received"
          );
          // Populate filter dropdown options (extract status names as strings)
          this.transactionStatus = response.data.details.map(item => item.status);
        }
      });
    },
    async fetchBlockedEntities() {
      await this.$store.dispatch(GET_BLOCKED_ENTITIES).then((response) => {
        if (response && response.data) {
          this.blockedEntities = response.data;
        }
      });
    },
    // get payment methods list
    async getAllPaymentMethods() {
      this.$store.dispatch(GET_ALL_PAYMENT_METHODS).then((response) => {
        this.paymentMethodOptions = [];
        if (response.data.code == "1010-000") {
          response.data.details.map((item) => {
            this.paymentMethodOptions.push({
              value: item.id,
              name: item.name,
            });
          });
        }
      });
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.getTransactionList();
      }
    },

    // For advance filter mobile money provider list
    async getAllMomonetworks() {
      let params = ``;
      // let params = `?countryid=${country_id}`;
      this.momoProviderList = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.momoProviderList = response.data.details;
          }
        });
    },

    // Called when user selects destination countries in the filter
    async getCountryWiseMomoProvider(selectedCountries) {
      // selectedCountries is an array of country objects
      const countryIds = Array.isArray(selectedCountries)
        ? selectedCountries.map((c) => c.countryid)
        : [];
      const countryIdString = countryIds.join(",");
      // console.log('Selected Dest. Country IDs (comma separated):', countryIdString);
      // await this.getAllMobilenetworks(countryIdString);
      let params = `?countryid=${countryIdString}`;
      this.momoProviderList = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.momoProviderList = response.data.details;
          }
        });
    },
    // (removed removeMobileNetwork)

    // remove Network filters
    removeNetwork(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.momoProviderList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },

    
    // get Country Wise Bank List
    async getCountryWiseBank(country_id) {
      let params = `?countryid=${country_id}&size=5000&page=1`;
      this.bank_options = [];
      const uniqueNames = new Set(); // track unique bank names
      await this.$store
        .dispatch(TRANSACTION_BANK_LIST, params)
        .then((response) => {
          if (response.status == 200) {
            const details = response.data.details;
            details.forEach((item) => {
              if (!uniqueNames.has(item.bank_name)) { // check for uniqueness
                uniqueNames.add(item.bank_name);

                this.bank_options.push({
                  id: item.id,
                  name: item.bank_name,
                  bank_code: item.bank_code, 
                });
              }
            });
          }
        });
    },

    // Edit bank account
    async bankAccountEdit(data){
      await this.getCountryWiseBank(data.destcountry?.countryid);
      this.updateBank.id = data.id;
      this.updateBank.bank = this.bank_options.filter(
        (item) => item.name === data.accno.acc
      )[0];
      this.updateBank.account = data.accno.no;
      this.updateBank.comment = "";
      this.$bvModal.show("editBankAccount");
    },
    // Update bank account
    updateBankAccount() {
      let params = {
        transactionid: this.updateBank.id,
        bank: this.updateBank.bank.name,
        bank_code: this.updateBank.bank.bank_code,
        bankid: this.updateBank.bank.id,
        account: this.updateBank.account,
        comment: this.updateBank.comment,
      };
      this.$store
        .dispatch(UPDATE_TRANSACTION_BANK_ACCOUNT, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.$bvModal.hide("editBankAccount");
            this.getTransactionList();
          } else {
            if (response.data.detail) {
              myFunction.showInfo(response.data.detail, "error");
            } else {
              myFunction.showInfo(response.data.message, "error");
            }
          }
        });
    },

    
    
    // Determine sync action label based on transaction reference and additional info
    getSyncActionLabel(item) {
      const hasAdditionalInfo =
        item?.additionalInfo === true ||
        item?.additionalInfo === "true" ||
        item?.additionalinfo === true ||
        item?.additionalinfo === "true";
      if (!hasAdditionalInfo) {
        return "";
      }

      const ref = (item?.custRefno || item?.reference_number || "")
        .toString()
        .trim()
        .toUpperCase();
      if (ref.startsWith("PM")) {
        return "Update MOMO Details";
      }
      if (ref.startsWith("PA")) {
        return "Update Bank Details";
      }
      return "";
    },

    // sync transaction details
    async syncAction(item) {
      const actionLabel = this.getSyncActionLabel(item);
      
      const bankMomoDetail = await this.getTransactionBankorMomoDetails(item.id);
      if(!bankMomoDetail){
        myFunction.showInfo("No bank or momo details found for this beneficiary.", "error");
      } else {
        if(bankMomoDetail.code === "1005-001" || bankMomoDetail.code === "1005-002"){
          myFunction.showInfo(bankMomoDetail.message, "success");
          this.getTransactionList();
        } else {
          if (actionLabel === "Update MOMO Details") {
            await this.momoEdit(item, bankMomoDetail.details);
          } else if (actionLabel === "Update Bank Details") {
            await this.bankdetailsEdit(item, bankMomoDetail.details);
          } else {
            myFunction.showInfo("No additional information available for sync", "info");
          }
        }        
      }      
    },

    // get bank or momo details for transaction
    async getTransactionBankorMomoDetails(transactionId) {
      const payload = {
          transactionId: transactionId
        };
      try {
        const response = await this.$store.dispatch(GET_TRANSACTION_MOMO_BANK_DETAIL, payload);
        if (response.status === 200) {
          return response.data;
        } else {
          return null;
        }
      } catch (error) {
        myFunction.showInfo("An error occurred while fetching transaction details", "error");
        return null;
      }
    },

    async momoEdit(transactiondata, momodata) {
      this.editMomoDetailsModal.transactiondata = transactiondata || null;
      this.editMomoDetailsModal.momodata = Array.isArray(momodata)
        ? momodata
        : momodata
        ? [momodata]
        : [];
      this.editMomoDetailsModal.selectedSection = null;
      this.editMomoDetailsModal.disableSubmit = this.editMomoDetailsModal.momodata.length > 1;
      this.editMomoDetailsModal.errorMessage = this.editMomoDetailsModal.disableSubmit
        ? 'Please contact with Tech team for update momo details.'
        : '';
      this.hoverSection = null;
      this.$bvModal.show('editMomoDetails');
    },

    selectMomoSection(section) {
      if (this.editMomoDetailsModal.disableSubmit && section === 'beneficiary') {
        return;
      }
      this.editMomoDetailsModal.selectedSection = section;
    },

    getSelectedMomoDetails() {
      const section = this.editMomoDetailsModal.selectedSection;
      if (!section) {
        return null;
      }

      if (section === 'transaction') {
        return {
          level: 'transaction',
          transactionId: this.editMomoDetailsModal.transactiondata?.uuid,
          mobileNetwork: this.editMomoDetailsModal.transactiondata?.accno?.acc,
          mobileNumber: this.editMomoDetailsModal.transactiondata?.accno?.no,
          raw: this.editMomoDetailsModal.transactiondata,
        };
      }

      if (section === 'beneficiary' && this.editMomoDetailsModal.momodata.length === 1) {
        const record = this.editMomoDetailsModal.momodata[0];
        return {
          level: 'beneficiary',
          transactionId: this.editMomoDetailsModal.transactiondata?.uuid,
          mobileNetwork: record.mobileNetwork,
          mobileNumber: record.mobileNumber,
          mobileNetworkId: record.networkid,
          raw: record,
        };
      }

      return null;
    },

    submitEditMomoDetails() {
      if (!this.editMomoDetailsModal.selectedSection) {
        return;
      }

      const selectedMomoDetails = this.getSelectedMomoDetails();
      if (!selectedMomoDetails) {
        myFunction.showInfo(
          'Selected MOMO detail is not available for update.',
          'error',
        );
        return;
      }

      let params = {
        updateLevel: selectedMomoDetails.level,
        transactionId: selectedMomoDetails.transactionId,
        mobileNumber: selectedMomoDetails.mobileNumber,
      };
      if(selectedMomoDetails.level === 'beneficiary'){
        params.networkid = selectedMomoDetails.mobileNetworkId;
      }
      this.$store
        .dispatch(UPDATE_TRANSACTION_BANK_MOMO_DETAILS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.$bvModal.hide("editMomoDetails");
            this.getTransactionList();
          } else {
            if (response.data.detail) {
              myFunction.showInfo(response.data.detail, "error");
            } else {
              myFunction.showInfo(response.data.message, "error");
            }
          }
        });
    },

    async bankdetailsEdit(transactiondata, bankdata) {
      this.editBankDetailsModal.transactiondata = transactiondata || null;
      this.editBankDetailsModal.bankdata = Array.isArray(bankdata)
        ? bankdata
        : bankdata
        ? [bankdata]
        : [];
      this.editBankDetailsModal.selectedSection = null;
      this.editBankDetailsModal.disableSubmit = this.editBankDetailsModal.bankdata.length > 1;
      this.editBankDetailsModal.errorMessage = this.editBankDetailsModal.disableSubmit
        ? 'Please contact with Tech team for update bank details.'
        : '';
      this.hoverSection = null;
      this.$bvModal.show('editBankDetails');
    },

    selectBankSection(section) {
      if (this.editBankDetailsModal.disableSubmit && section === 'beneficiary') {
        return;
      }
      this.editBankDetailsModal.selectedSection = section;
    },

    getSelectedBankDetails() {
      const section = this.editBankDetailsModal.selectedSection;
      if (!section) {
        return null;
      }

      if (section === 'transaction') {
        return {
          level: 'transaction',
          transactionId: this.editBankDetailsModal.transactiondata?.uuid,
          bankname: this.editBankDetailsModal.transactiondata?.accno?.acc,
          accountnumber: this.editBankDetailsModal.transactiondata?.accno?.no,
          raw: this.editBankDetailsModal.transactiondata,
        };
      }

      if (section === 'beneficiary' && this.editBankDetailsModal.bankdata.length === 1) {
        const record = this.editBankDetailsModal.bankdata[0];
        return {
          level: 'beneficiary',
          transactionId: this.editBankDetailsModal.transactiondata?.uuid,
          bankname: record.bankName,
          accountnumber: record.bankAccountNumber,
          bankId: record.bankId,
          raw: record,
        };
      }

      return null;
    },

    submitEditBankDetails() {
      if (!this.editBankDetailsModal.selectedSection) {
        return;
      }

      const selectedBankDetails = this.getSelectedBankDetails();
      if (!selectedBankDetails) {
        myFunction.showInfo(
          'Selected Bank detail is not available for update.',
          'error',
        );
        return;
      }

      let params = {
        updateLevel: selectedBankDetails.level,
        transactionId: selectedBankDetails.transactionId,
        bankAccountNumber: selectedBankDetails.accountnumber,
      };
      if(selectedBankDetails.level === 'beneficiary'){
        params.bankId = selectedBankDetails.bankId;
      }
      this.$store
        .dispatch(UPDATE_TRANSACTION_BANK_MOMO_DETAILS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.$bvModal.hide("editBankDetails");
            this.getTransactionList();
          } else {
            if (response.data.detail) {
              myFunction.showInfo(response.data.detail, "error");
            } else {
              myFunction.showInfo(response.data.message, "error");
            }
          }
        });

    },
  },
  // Only one correct definition, just before data()
  data() {
    return {
      blockedEntities: [],
      mobileInputError: true,
      isDisplayPhoneError: false,
      primaryMobileNumber: {
        mode: "auto",
        defaultCountry: "",
        autoFormat: false,
        dropdownOptions: {
          showFlags: true,
          disabled: true,
          showDialCodeInSelection: true,
        },
      },
      updateMobile: {
        id: "",
        network: "",
        phoneNumber: "",
        comment: "",
        countryCode: "",
      },
      network_options: [],
      updateBank: {
        id: "",
        bank: "",
        account: "",
        comment: "",
      },
      bank_options: [],
      // ENG-2035: "Send Reroute Request" drawer state. OPS CAN FIX path (MoMo & Bank).
      // Prepopulated from the Failed PM/PA row; submits to POST /api/v1/recovery-actions.
      rerouteDrawer: {
        show: false,
        item: null, // the transaction list row
        channel: "", // 'PM' (MoMo) | 'PA' (Bank)
        selectedCard: "OPS_CAN_FIX", // OPS_CAN_FIX | APPROVAL (APPROVAL form is ENG-2036)
        reasonCode: "",
        // MoMo (PM)
        network: "", // selected network object {id,name}
        phoneNumber: "", // national number (dial code prepended on submit)
        countryCode: "", // destcountry.mobilecountrycode, e.g. +233
        // Bank (PA)
        bank: "", // selected bank object {id,name,bank_code}
        account: "",
        // Name (APPROVAL / NAME_CORRECTION — ENG-2036)
        firstName: "",
        middleName: "",
        lastName: "",
        // shared
        evidenceRef: "",
        notes: "",
        // before snapshot (current values, for the Before/After panel)
        before: { network: "", phoneNumber: "", bank: "", account: "", firstName: "", middleName: "", lastName: "" },
        submitting: false,
        // spotlight: index + measured viewport rect of the clicked row
        rowIndex: -1,
        spotlightRect: null,
      },
      // ENG-2058: manual "Check name" lookup for the proposed number/account (display-only)
      rerouteCheckedName: "",
      rerouteNameCheckShow: false,
      rerouteReasonOptions: {
        PM: ["Wrong MoMo details", "Wallet Limit", "Account Closed", "Partner Returned payout"],
        PA: ["Wrong Bank details", "Account Closed", "Partner returned payout"],
      },
      editMomoDetailsModal: {
        transactiondata: null,
        momodata: [],
        selectedSection: null,
        disableSubmit: false,
        errorMessage: "",
      },
      editBankDetailsModal: {
        transactiondata: null,
        bankdata: [],
        selectedSection: null,
        disableSubmit: false,
        errorMessage: "",
      },
      hoverSection: null,
      transactionProcess: {
        transaction_id: "",
        status: "",
        reason: "",
        refundmethod: "",
        comment: "",
        providerid: "",
      },
      notification: {
        type: "",
        action: "",
        custom: "RE : [trans_ref_#]",
      },
      showAlertTop: false,
      comment_transaction: {
        type: "",
        comment: "",
      },
      transactionStatusUpdate: {
        transaction_id: "",
        status: "",
        comment: "",
      },
      payoutStatusUpdate: {
        transaction_id: "",
        provider: "",
        comment: "",
      },
      manualConfirm: {
        transaction_id: "",
        title: "",
        reference_number: "",
        status: "",
        comment: "",
      },
      paymentReconcile: {
        reference: "",
        result: null,
      },
      avsWarningPendingParams: null,
      avsWarningReason: '',
      displayFilters: [],
      IBDStatusUpdate: "Error",
      notificationTypeOptions: [
        "Push notification",
        "Dismiss popup",
        "Model popup",
        "SMS",
      ],
      notificationActionOptions: ["ID Notification", "Other"],
      filterField: [
        { id: "firstname", name: "Sender First Name", $isDisabled: false },
        { id: "middlename", name: "Sender Middle Name", $isDisabled: false },
        { id: "lastname", name: "Sender Last Name", $isDisabled: false },
        { id: "receiverfirstname", name: "Receiver First Name", $isDisabled: false },
        { id: "receivermiddlename", name: "Receiver Middle Name", $isDisabled: false },
        { id: "receiverlastname", name: "Receiver Last Name", $isDisabled: false },
        { id: "senderemail", name: "Sender Email", $isDisabled: false },
        { id: "receiveremail", name: "Receiver Email", $isDisabled: false },
        { id: "senderphone", name: "Sender Phone", $isDisabled: false },
        { id: "receiverphone", name: "Receiver Phone", $isDisabled: false },
        { id: "ip_address", name: "Registered IP", $isDisabled: false },
        { id: "country", name: "Dest. Country", $isDisabled: false },
        { id: "sourcecountry", name: "Source Country", $isDisabled: false },
        { id: "date", name: "Date", $isDisabled: false },
        { id: "remitterstatus", name: "Remitter Status", $isDisabled: false },
        {
          id: "transaction_status",
          name: "Transaction Status",
          $isDisabled: false,
        },
        { id: "transactiontype", name: "Transaction Type", $isDisabled: false },
        {
          id: "transaction_history",
          name: "Transaction History",
          $isDisabled: false,
        },
        {
          id: "transaction_ref",
          name: "Transaction Ref. ID",
          $isDisabled: false,
        },
        {
          id: "payment_id",
          name: "Payment Method",
          $isDisabled: false,
        },
        { id: "payment_res_id", name: "Payment Ref. ID", $isDisabled: false },
        { id: "payout_res_id", name: "Payout Ref. ID", $isDisabled: false },
        // { id: "payout_source", name: "Payout Source", $isDisabled: false },
        { id: "cko_capture", name: "CKO Capture Status", $isDisabled: false },
        { id: "amount", name: "Amount", $isDisabled: false },
        {
          id: "mobile_network",
          name: "Mobile Money Network",
          $isDisabled: false,
        },
        { id: "bank_name", name: "Bank Name", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "firstname", name: "Sender First Name", $isDisabled: false },
          search: "",
          country: [],
          transactionStatus: [],
          date: {
            from: "",
            to: "",
          },
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ],
      payoutSourceOption: [],
      momoProviderList: [],
      filterpayouttype: [
        { value: "mobilemoney", name: "Mobile Money" },
        { value: "IBOBank", name: "IBO Bank" },
      ],
      mobileNetworks: [
        { value: "airtel", name: "Airtel" },
        { value: "vodafone", name: "Vodafone" },
      ],
      banks: [
        { value: "royal bank", name: "Royal Bank" },
        { value: "world bank", name: "World Bank" },
        { value: "swiss bank", name: "Swiss Bank" },
      ],
      testFilter: false,
      dateRange: null,
      detailsstatus: false,
      errorMsg: "",
      customerDetail: null,
      remitterCredit: {
        customer: "",
        comment: "",
        amount: "",
        creditType: "",
        refundType: "",
      },

      transactionDetail: {
        accName: "",
        accNumber: "",
        sendername: "",
        beneficiaryname: "",
        srcamount: "",
        destamount: "",
        refno: "",
        transStatus: "",
        details: [],
      },

      transactions: [],
      transactionsCopy: [],
      // Linked-risk badges shown inline under the sender/receiver of each transaction.
      senderRisk: {},
      receiverRisk: {},
      riskLoading: false,

      fields: [
        {
          key: "selected",
          label: "Select",
          sortable: false,
          thStyle: { width: "2%", "padding-left": ".35rem !important" },
          thClass: "th_sortfix pl-0 text-left",
        },
        {
          key: "srccountry",
          label: "S.C.",
          sortable: false,
          thClass: "th_sortfix text-left",
        },
        {
          key: "datetime",
          label: "Date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "sender",
          label: "Sender",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "benificiary",
          label: "Receiver",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "accno",
          label: "Account No.",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "custRefno",
          label: "Trans. Ref",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "paymentMethod",
          label: "Payment Method",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "sourceamount",
          label: "Source Amount",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "destamount",
          label: "Dest Amount",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "status",
          label: "Trans. Status",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "payout",
          label: "Payout",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      selectAll: false,
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 100, 150, 200, { value: 1000, text: 1000 }],
      sortBy: "datetime",
      sortDesc: true,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      isVisibleFilter: false,

      searchText: "",

      tradename: {},
      tradename_options: [],
      tradenameid: "",
      remiterOption: [
        { value: "Basic", name: "Basic" },
        { value: "Bronze", name: "Bronze" },
        { value: "Silver", name: "Silver" },
        { value: "Silver Plus", name: "Silver Plus" },
      ],
      transactionStatus: [],
      // Constants for EUR Funds Received special case
      EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID: 'c911fab5-af81-4869-8da7-9a5465d456ec',
      EUR_FUNDS_RECEIVED_STATUS: 'Awaiting Funds',
      UpdateStatusoption: [],
      IBDStatusoption: [
        "Pending",
        "Success",
        "Error",
        "Failed",
        "Paid GT-OLB",
        "Paid NSANO",
        "Paid-CBG-ACH",
        "Paid-PGL",
        "ACH",
        "Paid HK PINOY",
      ],
      provideroption: [],
      bulkCapturestatus: "",
      bulkCaptureOption: [
        "GT-MDW",
        "NSANO",
        "ACH",
        "MIDDLE-WARE",
        "MDW-Rafiki",
        "MDW-PayAza",
        "MDW-CBG",
        "MDW-Terrapay",
        "MDW-Ghipss",
        "AZA-FIN",
        "MFS",
        "GTdirect-112",
        "PGL",
        "RIPPLE-NET",
        "Failed",
      ],
      payoutoption: [],
      typeoption: ["Customer", "Partner"],
      channelTypes: ["a", "b", "c"],
      amountOptions: [
        { id: "gte", name: "Greater Than", $isDisabled: false },
        { id: "lte", name: "Less Than", $isDisabled: false },
        { id: "eq", name: "Equals", $isDisabled: false },
      ],
      transactiontypeOptions: [
        "Mobile Money",
        "Bank Deposit",
        "Cash Collection",
      ],
      refund_method_Options: ["Wallet", "Account", "No Refund"],
      transactionReasons: [],
      paymentMethodOptions: [],
    };
  },
  async mounted() {
    this.totalRows = this.transactions.length;
    await this.getProvider();
    await this.getAllMomonetworks();
    await this.getTransactionStatus();
    await this.getAllPaymentMethods();
    await this.cookieFilters();
    await this.fetchBlockedEntities();
    // Ensure countryList is loaded before fetching transactions
    if (!this.countryList || this.countryList.length === 0) {
      await this.$store.dispatch(COUNTRYLIST);
    }
    this.getTransactionList();
    // React only to GENUINE mid-session HQ-access changes. The auth store fires this
    // event from refreshPermissions when the effective HQ-filter actually changes —
    // never on the initial discovery of the user's capability after login, and never
    // on a page refresh (the first authoritative load is adopted silently as the
    // baseline). This is what prevents the spurious loader + toast on tab return.
    window.addEventListener("hq-access-changed", this.onHqAccessChanged);
  },
  beforeDestroy() {
    window.removeEventListener("hq-access-changed", this.onHqAccessChanged);
  },
  watch: {
    // Switching between /transaction/middleware, /treasury and /business reuses this
    // component instance — mounted() does not re-run — so without this the new view
    // would render the previous team's rows until something else triggered a fetch.
    $route(to, from) {
      if (to.meta?.team === from.meta?.team) return;
      this.currentPage = this.currentPageJump = 1;
      this.getTransactionList();
    },
    displayFilters: {
      handler() {
        if (this.displayFilters.length > 0) {
          this.getTransactionList();
        }
      },
      immediate: false,
    },
    currentPage: {
      handler: function () {
        this.getTransactionList();
      },
    },
    perPage: {
      handler: function () {
        this.getTransactionList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
    // ENG-2348 — the team view this route renders ('ce' | 'treasury' | 'business'),
    // set by meta.team in main.js. One component serves all three; the route is the
    // only thing that differs, so nothing here is forked per team.
    teamScope() {
      return this.$route.meta && this.$route.meta.team
        ? this.$route.meta.team
        : "ce";
    },
    teamViewTitle() {
      return (
        (this.$route.meta && this.$route.meta.title) || "Transaction List"
      );
    },
    // Whether the logged-in user is a SuperAdmin (never HQ-restricted). Case-insensitive
    // for safety; kept live by the /permission/list poll.
    isSuperAdminUser() {
      const roles = this.$store.state.authpermission.roles || [];
      return roles.some((r) => (r || "").toLowerCase() === "superadmin");
    },
    // Transaction-type filter options shown in the dropdown. The base payout types are
    // available to everyone; "HQ Transactions" is a SuperAdmin-only filter (maps to
    // is_hq_tx=1 on the API, see applyTestfilter). Derived from transactiontypeOptions
    // so the base list stays the single source of truth.
    transactionTypeFilterOptions() {
      return this.isSuperAdminUser
        ? [...this.transactiontypeOptions, "HQ Transactions"]
        : this.transactiontypeOptions;
    },
  },
};
</script>
<style>
/* ENG-1996 — pending reroute pill + popover */
.reroute-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border: 1px solid #f0ad4e;
  border-radius: 12px;
  background: #fff8ec;
  color: #b06d0f;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.reroute-pill:hover {
  background: #fdeccd;
}
.reroute-pill .fa-info-circle {
  color: #c98a1e;
}
.popover.reroute-popover {
  background-color: var(--primary-color-500, #50e3c2);
  border: none;
  max-width: 360px;
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(8, 48, 42, 0.28);
}
/* Round header/body corners individually rather than clipping the popover with
   overflow:hidden, which would cut off the arrow (it sits outside the box). */
.popover.reroute-popover .popover-header {
  background-color: rgba(8, 48, 42, 0.08);
  color: #08302a;
  border-bottom: 1px solid rgba(8, 48, 42, 0.12);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  padding: 0.5rem 0.85rem;
}
.popover.reroute-popover .popover-body {
  color: #0b3d35;
  font-size: 0.8rem;
  padding: 0.4rem 0.85rem;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
/* Colour BOTH arrow layers (::before is bootstrap's border layer) so the triangle
   merges flush into the box instead of showing a seam — !important to win over
   bootstrap's placement-specific arrow rules regardless of load order. */
.popover.reroute-popover .arrow::before,
.popover.reroute-popover .arrow::after {
  border-top-color: var(--primary-color-500, #50e3c2) !important;
  border-bottom-color: var(--primary-color-500, #50e3c2) !important;
}
/* Bootstrap draws a 1rem line under the arrow on the header (::before) in the default
   light header colour — kill it so no white sliver shows beneath the triangle. */
.popover.reroute-popover .popover-header::before {
  border-bottom-color: transparent !important;
}
.reroute-popover-item {
  padding: 5px 0;
  white-space: normal;
  overflow-wrap: break-word;
  border-bottom: 1px solid rgba(8, 48, 42, 0.1);
}
.reroute-popover-item:last-child {
  border-bottom: none;
}
.reroute-popover-item strong {
  color: #08302a;
  font-weight: 700;
}
/* Meta ("by … on …") on its own indented line so a long maker name + date never
   wraps mid-sentence against the label. */
.reroute-popover-meta {
  margin-left: 14px;
  font-size: 0.72rem;
  opacity: 0.85;
}
.reroute-popover-dot {
  color: #08302a;
  margin-right: 6px;
}
text-grey {
  color: #8a8a8a !important;
}
.transaction-details-body {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
}
.transaction-raw-details-body {
  display: block;
  margin-left: 10px;
  width: 65%;
}
.transaction-raw-details-body .hide {
  display: none;
}
.transaction-lg-modal {
  max-width: 800px;
}
.beneficiary-scroll {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}
.scroll {
  overflow-y: scroll;
}
.max-width {
  width: 100%;
}
.transaction-alert {
  position: fixed;
  z-index: 9999;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>

<style scoped>
/* Readable inline risk pills under the sender/receiver of each transaction. */
.risk-pill {
  border: 1px solid;
  border-radius: 12px;
  padding: 1px 8px;
  font-size: 10px;
  font-weight: 700;
  width: fit-content;
}
.risk-pill.risk-low {
  color: #256a37;
  border-color: #9ccaa9;
  background: #eef8f1;
}
.risk-pill.risk-medium {
  color: #8a6d00;
  border-color: #e2c15a;
  background: #fdf6e3;
}
.risk-pill.risk-high {
  color: #a72727;
  border-color: #e2a1a1;
  background: #fdeeee;
}
/* Loading placeholder shown until the risk batch resolves (avoids pop-in / "no risk" look). */
.risk-skeleton {
  width: 68px;
  height: 16px;
  border-radius: 12px;
  background: linear-gradient(90deg, #eef1f4 25%, #e2e7ec 37%, #eef1f4 63%);
  background-size: 400% 100%;
  animation: risk-shimmer 1.2s ease-in-out infinite;
}
@keyframes risk-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
/* Loaded but no risk to show (e.g. self-transfer) — explicit, not a blank gap. */
.risk-na {
  font-size: 10px;
  font-weight: 700;
  color: #8a97a3;
}
</style>
